// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--preset-card);
  border-radius: 4px;
}

.heartbeat-container {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  container-type: inline-size;
  container-name: heartbeat;
}

.presence-dot {
  font-size: 12px;
  width: 12px;
  height: 12px;
  min-width: 12px;
  overflow: visible;
  transition: color 0.3s;
}

.agent-sidebar {
  flex-shrink: 0;
  min-width: 150px;
  max-width: 400px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-resize-divider {
  width: 4px;
  cursor: ew-resize;
  background-color: transparent;
  transition: background-color 0.15s ease, width 0.15s ease;
  flex-shrink: 0;
}
.sidebar-resize-divider:hover {
  background-color: rgba(128, 128, 128, 0.35);
}
.sidebar-resize-divider.collapsed {
  width: 6px;
  cursor: e-resize;
  opacity: 0.7;
}
.sidebar-resize-divider.collapsed:hover {
  width: 8px;
  opacity: 1;
}

.nav-tree {
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
}

.nav-section-header {
  display: flex;
  align-items: center;
  padding: 6px 8px 2px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}
.nav-section-header:not(:first-child) {
  margin-top: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 8px;
}
.nav-section-header:hover {
  background: rgba(255, 255, 255, 0.04);
}
.nav-section-header .nav-section-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.6;
  flex: 1;
}

.nav-expand-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  min-width: 16px;
  opacity: 0.5;
  margin-right: 2px;
}

.nav-add-btn {
  width: 20px;
  height: 20px;
  padding: 0;
  opacity: 0.6;
  transition: opacity 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-add-btn:first-of-type {
  margin-left: auto;
}
.nav-add-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 20px;
  height: 20px;
}
.nav-add-btn mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  line-height: 14px;
}

.nav-channel-item {
  display: flex;
  align-items: center;
  padding: 3px 10px 3px 14px;
  margin: 1px 6px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
  min-height: 28px;
}
.nav-channel-item:hover {
  background: rgba(255, 255, 255, 0.06);
}
.nav-channel-item.selected {
  background: rgba(244, 172, 57, 0.12) !important;
}
.nav-channel-item.selected .nav-channel-icon {
  color: #f4ac39 !important;
  opacity: 1 !important;
}
.nav-channel-item.selected .nav-channel-name {
  font-weight: 600 !important;
}
.nav-channel-item .nav-channel-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  min-width: 14px;
  opacity: 0.5;
  margin-right: 6px;
}
.nav-channel-item .nav-channel-name {
  font-size: 13px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.channel-activity-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 4px;
}
.channel-activity-dot.streaming {
  background: #64b5f6;
  animation: channel-pulse 1.2s ease-in-out infinite;
}
.channel-activity-dot.unread {
  background: #81c784;
}

.nav-bg-agent-item.selected {
  background: rgba(244, 172, 57, 0.12) !important;
}
.nav-bg-agent-item.selected .nav-bg-agent-icon {
  opacity: 1;
}
.nav-bg-agent-item.selected .nav-ws-title {
  opacity: 1;
  font-weight: 600;
}
.nav-bg-agent-item .nav-bg-agent-icon {
  color: #f4ac39;
  opacity: 0.85;
}
.nav-bg-agent-item .nav-ws-title {
  font-style: italic;
  flex: 1;
  min-width: 0;
}
.nav-bg-agent-item .nav-bg-agent-elapsed {
  font-size: 10px;
  opacity: 0.55;
  margin: 0 6px;
  white-space: nowrap;
}
.nav-bg-agent-item.nav-bg-agent-nested {
  padding-left: 46px;
}

.main-area.bg-agent-open > :not(.header-bar):not(.bg-agent-view) {
  display: none !important;
}

.bg-agent-view {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.bg-agent-view .bg-agent-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 4px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.bg-agent-view .bg-agent-strip .bg-agent-strip-icon {
  color: #f4ac39;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bg-agent-view .bg-agent-strip .bg-agent-strip-title {
  font-weight: 600;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bg-agent-view .bg-agent-strip .bg-agent-strip-meta {
  font-size: 12px;
  opacity: 0.6;
  white-space: nowrap;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bg-agent-view .bg-agent-task {
  margin: 8px 14px 0;
  padding: 6px 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  font-size: 13px;
  max-height: 40%;
  overflow: auto;
}
.bg-agent-view .bg-agent-task summary {
  cursor: pointer;
  opacity: 0.7;
}
.bg-agent-view .bg-agent-note {
  margin: 8px 14px 0;
  font-size: 12px;
  opacity: 0.6;
}
.bg-agent-view .bg-agent-note.bg-agent-error {
  color: #e57373;
  opacity: 1;
}
.bg-agent-view .message-area {
  flex: 1;
  min-height: 0;
}

.nav-channel-item .nav-add-child {
  margin-left: auto;
  font-size: 16px;
  width: 16px;
  height: 16px;
  min-width: 16px;
  opacity: 0;
  border-radius: 4px;
  transition: opacity 0.15s;
}
.nav-channel-item .nav-add-child:hover {
  opacity: 1 !important;
  background: rgba(255, 255, 255, 0.12);
}

.nav-channel-item:hover .nav-add-child {
  opacity: 0.55;
}

.nav-channel-draft input {
  flex: 1;
  min-width: 0;
  font: inherit;
  font-size: 12px;
  color: inherit;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(244, 172, 57, 0.5);
  border-radius: 4px;
  padding: 2px 6px;
  outline: none;
}

.nav-work-session-item {
  display: flex;
  align-items: center;
  padding: 2px 10px 2px 30px;
  margin: 0 6px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s;
  min-height: 24px;
}
.nav-work-session-item:hover {
  background: rgba(255, 255, 255, 0.06);
}
.nav-work-session-item.selected {
  background: rgba(244, 172, 57, 0.12) !important;
}
.nav-work-session-item.selected .nav-ws-icon {
  color: #f4ac39;
  opacity: 1;
}
.nav-work-session-item.selected .nav-ws-title {
  opacity: 1;
  font-weight: 600;
}
.nav-work-session-item .nav-ws-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  min-width: 13px;
  opacity: 0.4;
  margin-right: 6px;
}
.nav-work-session-item .nav-ws-icon.ws-active {
  color: #4caf50;
  opacity: 0.8;
}
.nav-work-session-item .nav-ws-title {
  font-size: 12px;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.nav-empty {
  padding: 6px 24px;
  font-size: 12px;
  opacity: 0.35;
  font-style: italic;
}

.nav-agents-section {
  padding: 0;
}

.nav-dm-section {
  padding: 0;
}

.nav-dm-item {
  display: flex;
  align-items: center;
  padding: 6px 10px 6px 14px;
  margin: 1px 6px;
  border-radius: 6px;
  cursor: pointer;
  gap: 10px;
  transition: background 0.15s;
}
.nav-dm-item:hover {
  background: rgba(255, 255, 255, 0.06);
}
.nav-dm-item.selected {
  background: rgba(244, 172, 57, 0.12) !important;
}
.nav-dm-item.selected .nav-dm-name {
  font-weight: 600 !important;
}
.nav-dm-item .nav-dm-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.nav-dm-item .nav-dm-info .nav-dm-name {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav-dm-item .nav-dm-info .nav-dm-status {
  font-size: 11px;
  opacity: 0.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav-dm-item .nav-throttle-btn {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  line-height: 24px;
  flex-shrink: 0;
  opacity: 0.4;
  transition: opacity 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-dm-item .nav-throttle-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 24px;
  height: 24px;
}
.nav-dm-item .nav-throttle-btn .mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}
.nav-dm-item .nav-throttle-btn.throttle-enabled .mat-icon {
  color: #4caf50;
}
.nav-dm-item .nav-throttle-btn.throttle-safe .mat-icon {
  color: #ff9800;
}
.nav-dm-item .nav-throttle-btn.throttle-interrupted .mat-icon {
  color: #ff9800;
  animation: interrupt-pulse 1s ease-in-out infinite;
}
.nav-dm-item .nav-throttle-btn.throttle-enabled, .nav-dm-item .nav-throttle-btn.throttle-safe, .nav-dm-item .nav-throttle-btn.throttle-interrupted {
  opacity: 1;
}
.nav-dm-item:hover .nav-throttle-btn {
  opacity: 0.8;
}
.nav-dm-item:hover .nav-throttle-btn.throttle-enabled, .nav-dm-item:hover .nav-throttle-btn.throttle-safe, .nav-dm-item:hover .nav-throttle-btn.throttle-interrupted {
  opacity: 1;
}

@keyframes interrupt-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
.archive-channel-btn {
  opacity: 0.35;
  transition: opacity 0.15s ease;
}
.archive-channel-btn:hover {
  opacity: 0.8;
}

.square-button {
  --square-button-size: 28px;
  --square-icon-size: 18px;
  width: var(--square-button-size);
  height: var(--square-button-size);
  padding: 0;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.square-button mat-icon {
  width: var(--square-icon-size);
  height: var(--square-icon-size);
  line-height: var(--square-icon-size);
  font-size: var(--square-icon-size);
  display: flex;
  align-items: center;
  justify-content: center;
}
.square-button ::ng-deep .mat-mdc-button-persistent-ripple {
  border-radius: 0.5rem;
}
.square-button ::ng-deep .mat-mdc-button-touch-target {
  width: var(--square-button-size);
  height: var(--square-button-size);
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.agent-tab-row {
  position: relative;
}
.agent-tab-row .add-agent-tab-btn {
  position: absolute;
  top: 0;
  right: 32px;
  width: 32px;
  height: 33px;
  padding: 0;
  line-height: 33px;
  text-align: center;
  z-index: 1;
  opacity: 0.4;
  transition: opacity 0.15s;
  overflow: hidden;
}
.agent-tab-row .add-agent-tab-btn:hover {
  opacity: 1;
}
.agent-tab-row .add-agent-tab-btn ::ng-deep .mat-mdc-button-persistent-ripple,
.agent-tab-row .add-agent-tab-btn ::ng-deep .mat-mdc-button-touch-target,
.agent-tab-row .add-agent-tab-btn ::ng-deep .mat-mdc-focus-indicator,
.agent-tab-row .add-agent-tab-btn ::ng-deep .mat-ripple.mat-mdc-button-ripple {
  top: -4px;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.agent-tab-row .add-agent-tab-btn .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-top: -7px;
}

.agent-tab-group {
  --preset-primary: rgba(128, 128, 128, 0.5) !important;
}
.agent-tab-group ::ng-deep .mat-mdc-tab-header {
  display: none !important;
}
.agent-tab-group ::ng-deep .mat-mdc-tab-header {
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}
.agent-tab-group ::ng-deep .mat-mdc-tab-labels {
  gap: 0;
  padding-right: 64px;
}
.agent-tab-group ::ng-deep .mat-mdc-tab {
  min-width: 0;
  padding: 0 14px;
  height: 32px;
  min-height: 32px;
  opacity: 0.45 !important;
  transition: opacity 0.15s, background-color 0.15s;
}
.agent-tab-group ::ng-deep .mat-mdc-tab .mdc-tab__ripple {
  background-color: transparent !important;
}
.agent-tab-group ::ng-deep .mat-mdc-tab:hover {
  opacity: 0.7 !important;
}
.agent-tab-group ::ng-deep .mat-mdc-tab.mdc-tab--active {
  opacity: 1 !important;
  border-radius: 0;
}
.agent-tab-group ::ng-deep .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  font-weight: 600;
}
.agent-tab-group ::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
}
.agent-tab-group ::ng-deep .mat-mdc-tab-header {
  --mat-tab-active-indicator-color: rgba(128, 128, 128, 0.5);
  --mat-tab-active-focus-indicator-color: rgba(128, 128, 128, 0.5);
  --mat-tab-active-hover-indicator-color: rgba(128, 128, 128, 0.5);
  --mat-tab-active-indicator-color: rgba(128, 128, 128, 0.5);
}
.agent-tab-group ::ng-deep .mat-mdc-tab-header .mdc-tab-indicator__content--underline {
  border-top-width: 2px !important;
  border-color: rgba(128, 128, 128, 0.5) !important;
  border-top-color: rgba(128, 128, 128, 0.5) !important;
}
.agent-tab-group ::ng-deep .mat-mdc-tab-body-wrapper {
  flex: none;
}
.agent-tab-group ::ng-deep .mat-mdc-tab-body-content {
  overflow: visible;
}

:host-context(.dark) .agent-tab-group ::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  color: rgba(255, 255, 255, 0.5) !important;
}
:host-context(.dark) .agent-tab-group ::ng-deep .mat-mdc-tab.mdc-tab--active {
  background-color: rgba(255, 255, 255, 0.12) !important;
}
:host-context(.dark) .agent-tab-group ::ng-deep .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #fff !important;
}

:host-context(.light) .agent-tab-group ::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  color: rgba(0, 0, 0, 0.55) !important;
}
:host-context(.light) .agent-tab-group ::ng-deep .mat-mdc-tab.mdc-tab--active {
  background-color: rgba(0, 0, 0, 0.07) !important;
}
:host-context(.light) .agent-tab-group ::ng-deep .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: rgba(0, 0, 0, 0.95) !important;
}

.agent-tab-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.no-agent-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.6;
}

.add-agent-tab-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.5;
  transition: opacity 0.15s;
}
.add-agent-tab-icon:hover {
  opacity: 1;
}

.agent-tab-body {
  display: flex;
  flex-direction: column;
}

.pill-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.agent-controls-inline {
  display: flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px 6px;
}
.agent-controls-inline button[mat-icon-button] {
  width: 28px;
  height: 28px;
  padding: 0;
  line-height: 28px;
  opacity: 0.5;
  transition: opacity 0.15s;
}
.agent-controls-inline button[mat-icon-button]:hover {
  opacity: 0.85;
}
.agent-controls-inline button[mat-icon-button] ::ng-deep .mat-mdc-button-touch-target {
  width: 28px;
  height: 28px;
}
.agent-controls-inline button[mat-icon-button] mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.agent-controls-inline button[mat-icon-button].ambient-active {
  opacity: 1;
  animation: mic-pulse 1.5s ease-in-out infinite;
}
.agent-controls-inline button[mat-icon-button].ambient-active mat-icon {
  color: #ef5350;
}
.agent-controls-inline button[mat-icon-button].throttle-enabled {
  opacity: 1;
}
.agent-controls-inline button[mat-icon-button].throttle-enabled mat-icon {
  color: #4caf50;
}
.agent-controls-inline button[mat-icon-button].throttle-safe {
  opacity: 1;
}
.agent-controls-inline button[mat-icon-button].throttle-safe mat-icon {
  color: #ff9800;
}
.agent-controls-inline button[mat-icon-button].throttle-interrupted {
  opacity: 1;
}
.agent-controls-inline button[mat-icon-button].throttle-interrupted mat-icon {
  color: #ff9800;
  animation: interrupt-pulse 1s ease-in-out infinite;
}

.model-select-inline {
  font-size: 11px;
  width: auto;
  min-width: 48px;
  max-width: 340px;
  opacity: 0.55;
  transition: opacity 0.15s;
  flex-shrink: 0;
}
.model-select-inline:hover {
  opacity: 0.85;
}
.model-select-inline ::ng-deep .mat-mdc-select-trigger {
  padding: 2px 4px;
  min-height: unset;
  height: 24px;
}
.model-select-inline ::ng-deep .mat-mdc-select-value {
  font-size: 11px;
  color: inherit;
}
.model-select-inline ::ng-deep .mat-mdc-select-arrow-wrapper {
  transform: scale(0.65);
}

.effort-badge {
  font-size: 9px;
  opacity: 0.6;
  margin-left: 2px;
}
.effort-badge::before {
  content: "·";
  margin-right: 2px;
}

.usage-bars-inline {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-width: 96px;
  width: auto;
  margin-left: 8px;
  margin-right: 10px;
  justify-content: center;
  padding: 6px 0;
  cursor: default;
}

.usage-bar-strip {
  height: 4px;
  width: 100%;
  background: rgba(128, 128, 128, 0.15);
  flex-shrink: 0;
  border-radius: 2px;
  position: relative;
  cursor: default;
}

.usage-bar-fill {
  height: 100%;
  transition: width 0.4s ease;
  border-radius: 2px;
}
.usage-bar-fill.usage-normal {
  background: #5a9e5d;
}
.usage-bar-fill.usage-warning {
  background: #d9a038;
}
.usage-bar-fill.usage-critical {
  background: #c8625a;
}

.usage-bar-label {
  position: absolute;
  right: 4px;
  top: -1px;
  font-size: 8px;
  line-height: 1;
  opacity: 0;
  color: currentColor;
  pointer-events: none;
  transition: opacity 0.15s;
}
.usage-bar-strip:hover .usage-bar-label {
  opacity: 1;
}

::ng-deep .multiline-tooltip .mdc-tooltip__surface {
  white-space: pre-line;
  text-align: left;
  max-width: 350px;
}

.agent-pill-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
.agent-pill-btn:hover {
  opacity: 0.85;
}
.agent-pill-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 28px;
  height: 28px;
}
.agent-pill-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-bar {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.header-bar .section {
  display: flex;
  align-items: center;
  gap: 4px;
}
.header-bar .section.left {
  flex: 1;
  overflow: hidden;
}
.header-bar .section.right {
  margin-left: auto;
  flex-shrink: 0;
}
.header-bar .section.agent-controls {
  flex-shrink: 0;
}
.header-bar .section.right button[mat-icon-button], .header-bar .section.agent-controls button[mat-icon-button] {
  width: 28px;
  height: 28px;
  padding: 0;
  line-height: 28px;
  opacity: 0.5;
  transition: opacity 0.15s;
}
.header-bar .section.right button[mat-icon-button]:hover, .header-bar .section.agent-controls button[mat-icon-button]:hover {
  opacity: 0.85;
}
.header-bar .section.right button[mat-icon-button] ::ng-deep .mat-mdc-button-touch-target, .header-bar .section.agent-controls button[mat-icon-button] ::ng-deep .mat-mdc-button-touch-target {
  width: 28px;
  height: 28px;
}
.header-bar .section.right button[mat-icon-button] mat-icon, .header-bar .section.agent-controls button[mat-icon-button] mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.header-bar .section.right button[mat-icon-button].ambient-active, .header-bar .section.agent-controls button[mat-icon-button].ambient-active {
  opacity: 1;
  animation: mic-pulse 1.5s ease-in-out infinite;
}
.header-bar .section.right button[mat-icon-button].ambient-active mat-icon, .header-bar .section.agent-controls button[mat-icon-button].ambient-active mat-icon {
  color: #ef5350;
}
.header-bar .section.right button[mat-icon-button].throttle-enabled, .header-bar .section.agent-controls button[mat-icon-button].throttle-enabled {
  opacity: 1;
}
.header-bar .section.right button[mat-icon-button].throttle-enabled mat-icon, .header-bar .section.agent-controls button[mat-icon-button].throttle-enabled mat-icon {
  color: #4caf50;
}
.header-bar .section.right button[mat-icon-button].throttle-safe, .header-bar .section.agent-controls button[mat-icon-button].throttle-safe {
  opacity: 1;
}
.header-bar .section.right button[mat-icon-button].throttle-safe mat-icon, .header-bar .section.agent-controls button[mat-icon-button].throttle-safe mat-icon {
  color: #ff9800;
}
.header-bar .section.right button[mat-icon-button].throttle-interrupted, .header-bar .section.agent-controls button[mat-icon-button].throttle-interrupted {
  opacity: 1;
}
.header-bar .section.right button[mat-icon-button].throttle-interrupted mat-icon, .header-bar .section.agent-controls button[mat-icon-button].throttle-interrupted mat-icon {
  color: #ff9800;
  animation: interrupt-pulse 1s ease-in-out infinite;
}
.header-bar .sidebar-toggle {
  opacity: 0.6;
}
.header-bar .sidebar-toggle:hover {
  opacity: 1;
}
.header-bar .header-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
}
.header-bar .header-title.clickable-name {
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 6px;
  margin: -2px -6px;
  transition: background 0.15s;
}
.header-bar .header-title.clickable-name:hover {
  background: rgba(255, 255, 255, 0.08);
}
.header-bar .header-presence-dot {
  font-size: 10px;
  width: 10px;
  height: 10px;
  transition: color 0.3s;
}
.header-bar .header-presence-dot.pulsing {
  animation: pulse 1.5s ease-in-out infinite;
}
.header-bar .header-channel-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.5;
}
.header-bar .switcher-arrow {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.5;
  margin-left: -2px;
}

.channel-agent-badge {
  display: none;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  opacity: 0.7;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: opacity 0.15s, background 0.15s;
}
.channel-agent-badge:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.08);
}
.channel-agent-badge .pill-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.channel-agent-badge .badge-arrow {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.5;
  margin-left: -2px;
}

.header-fav {
  font-size: 0.8rem;
  opacity: 1;
  padding: 2px 6px;
  border-radius: 4px;
  -webkit-user-select: none;
          user-select: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}
.header-fav:hover {
  opacity: 0.9;
  background-color: rgba(128, 128, 128, 0.15);
}
.header-fav .fav-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.header-fav .fav-icon.pin-active {
  color: var(--tool-accent, #1976d2);
}
.header-fav.chip-active {
  background-color: rgba(128, 128, 128, 0.15);
}

::ng-deep .fav-menu-item .mdc-list-item__primary-text,
::ng-deep .fav-menu-item .mat-mdc-menu-item-text {
  display: flex !important;
  align-items: center;
  width: 100%;
  gap: 4px;
}
::ng-deep .fav-menu-item .fav-spacer {
  flex: 1 1 0;
  min-width: 8px;
}
::ng-deep .fav-menu-item .reorder-arrow {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
::ng-deep .fav-menu-item .reorder-arrow.disabled {
  cursor: default;
}
::ng-deep .fav-menu-item:hover .reorder-arrow {
  opacity: 0.3;
}
::ng-deep .fav-menu-item:hover .reorder-arrow:hover:not(.disabled) {
  opacity: 1;
}
::ng-deep .fav-menu-item:hover .reorder-arrow.disabled {
  opacity: 0.1;
}
::ng-deep .fav-menu-item .fav-star {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.35;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
::ng-deep .fav-menu-item .fav-star:hover {
  opacity: 1;
}

::ng-deep .agent-visibility-menu .agent-vis-menu-item .mdc-list-item__primary-text,
::ng-deep .agent-visibility-menu .agent-vis-menu-item .mat-mdc-menu-item-text {
  display: flex !important;
  align-items: center;
  width: 100%;
  gap: 6px;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .pill-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .agent-vis-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .fav-spacer {
  flex: 1 1 0;
  min-width: 8px;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .reorder-arrow {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .reorder-arrow.disabled {
  cursor: default;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item:hover .reorder-arrow {
  opacity: 0.3;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item:hover .reorder-arrow:hover:not(.disabled) {
  opacity: 1;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item:hover .reorder-arrow.disabled {
  opacity: 0.1;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .fav-star {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.35;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
::ng-deep .agent-visibility-menu .agent-vis-menu-item .fav-star:hover {
  opacity: 1;
}

.message-area {
  flex: 1;
  overflow: hidden;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.safe-mode-active {
  animation: pulse-safe-mode 2s ease-in-out infinite;
}

@keyframes pulse-safe-mode {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.3);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(229, 57, 53, 0);
  }
}
.interrupt-active {
  animation: pulse 1.5s ease-in-out infinite;
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.3;
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}
.empty-state p {
  font-size: 14px;
}

.input-resize-divider {
  height: 4px;
  cursor: ns-resize;
  background-color: transparent;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
}
.input-resize-divider:hover {
  background-color: rgba(128, 128, 128, 0.35);
}

.input-area {
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.input-area ::ng-deep .mat-mdc-tab-body-wrapper {
  flex: 1 1 auto !important;
  min-height: 0;
}
.input-area ::ng-deep .mat-mdc-tab-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.input-area ::ng-deep .mat-mdc-tab-body-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.input-area .agent-tab-group {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.input-area .agent-tab-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.input-area app-chat-input {
  margin-bottom: 5px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.input-area app-chat-input ::ng-deep .prompt-box {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  max-width: none !important;
  padding: 0 12px !important;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
}
.input-area app-chat-input ::ng-deep .mat-mdc-form-field {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.input-area app-chat-input ::ng-deep .mat-mdc-text-field-wrapper {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.input-area app-chat-input ::ng-deep .mdc-text-field {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.input-area app-chat-input ::ng-deep .mat-mdc-form-field-flex {
  flex: 1 1 auto;
  align-items: stretch;
  min-height: 0;
  overflow: hidden;
}
.input-area app-chat-input ::ng-deep .mat-mdc-form-field-infix {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.input-area app-chat-input ::ng-deep textarea {
  flex: 1 1 auto;
  max-height: none !important;
  resize: none;
  overflow-y: auto !important;
}

.pins-resize-divider {
  width: 4px;
  cursor: ew-resize;
  background-color: var(--resize-divider-color, transparent);
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}
.pins-resize-divider:hover {
  background-color: var(--primary-color, #1976d2);
  opacity: 0.5;
}

.pins-pane {
  min-width: 15%;
  max-width: 50%;
  flex-shrink: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.pins-pane .pins-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.pins-pane .pins-header .pins-header-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.7;
}
.pins-pane .pins-header .pins-title {
  font-weight: 600;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pins-pane .pins-header .pins-node-count {
  font-size: 11px;
  opacity: 0.6;
  margin-left: -4px;
}
.pins-pane .pins-header .flex-spacer {
  flex: 1;
}
.pins-pane .search-tabs {
  display: flex;
  padding: 0 8px;
  gap: 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.pins-pane .search-tabs .search-tab {
  flex: 1;
  background: transparent;
  border: none;
  color: inherit;
  font-size: 12px;
  padding: 6px 0;
  cursor: pointer;
  opacity: 0.5;
  border-bottom: 2px solid transparent;
  transition: opacity 0.15s, border-color 0.15s;
}
.pins-pane .search-tabs .search-tab:hover {
  opacity: 0.8;
}
.pins-pane .search-tabs .search-tab.active {
  opacity: 1;
  border-bottom-color: rgba(255, 255, 255, 0.6);
}
.pins-pane .search-input-bar {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  gap: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.pins-pane .search-input-bar .search-pane-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: inherit;
  font-size: 12px;
  padding: 5px 8px;
  outline: none;
}
.pins-pane .search-input-bar .search-pane-input:focus {
  border-color: rgba(255, 255, 255, 0.25);
}
.pins-pane .search-input-bar .search-pane-input::placeholder {
  opacity: 0.4;
}
.pins-pane .search-input-bar .search-regex-toggle .regex-label {
  font-size: 12px;
  font-family: monospace;
  font-weight: 600;
  opacity: 0.5;
}
.pins-pane .search-input-bar .search-regex-toggle.active .regex-label {
  opacity: 1;
  color: #90caf9;
}
.pins-pane .search-result-count {
  padding: 4px 12px;
  font-size: 11px;
  opacity: 0.5;
}
.pins-pane .pins-graph-container {
  flex: 1;
  overflow: hidden;
  position: relative;
}
.pins-pane .pins-graph-container app-knowledge-graph-widget {
  display: block;
  width: 100%;
  height: 100%;
}
.pins-pane .pins-graph-container app-knowledge-graph-widget ::ng-deep .widget-body {
  height: 100%;
}
.pins-pane .pins-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.pins-pane .pin-card {
  padding: 10px 12px;
}
.pins-pane .pin-card.kg-card {
  height: 158px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.pins-pane .pin-card.kg-card .pin-card-header {
  flex-shrink: 0;
}
.pins-pane .pin-card.kg-card .pin-card-content {
  max-height: none;
  flex: 1;
}
.pins-pane .pin-card .pin-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  flex-shrink: 0;
}
.pins-pane .pin-card .pin-card-header .pin-role-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.pins-pane .pin-card .pin-card-header .pin-timestamp {
  font-size: 11px;
  opacity: 0.7;
}
.pins-pane .pin-card .pin-card-header .kg-jump-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  opacity: 0;
  transition: opacity 0.15s;
  color: rgba(255, 255, 255, 0.5);
}
.pins-pane .pin-card .pin-unpin-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: #f4ac39;
  opacity: 0.7;
  cursor: pointer;
}
.pins-pane .pin-card .pin-unpin-icon:hover {
  opacity: 1;
}
.pins-pane .pin-card.clickable {
  cursor: pointer;
  transition: background 0.15s;
}
.pins-pane .pin-card.clickable:hover {
  background: rgba(255, 255, 255, 0.06);
}
.pins-pane .pin-card.clickable:hover .kg-jump-icon {
  opacity: 1;
}
.pins-pane .pin-card .pin-card-content {
  font-size: 13px;
  line-height: 1.5;
  overflow: hidden;
  max-height: 120px;
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}
.pins-pane .pin-card .pin-card-content ::ng-deep h1, .pins-pane .pin-card .pin-card-content ::ng-deep h2, .pins-pane .pin-card .pin-card-content ::ng-deep h3, .pins-pane .pin-card .pin-card-content ::ng-deep h4 {
  font-size: 14px;
  margin: 4px 0;
}
.pins-pane .pin-card .pin-card-content ::ng-deep p {
  margin: 4px 0;
}
.pins-pane .pin-card .pin-card-content ::ng-deep pre {
  font-size: 11px;
  padding: 6px;
  overflow-x: auto;
}
.pins-pane .pin-card .pin-card-content ::ng-deep ul, .pins-pane .pin-card .pin-card-content ::ng-deep ol {
  padding-left: 20px;
  margin: 4px 0;
}
.pins-pane .pin-card .pin-card-content ::ng-deep code {
  font-size: 12px;
}
.pins-pane .pin-card .pin-card-content ::ng-deep app-tool-message {
  display: block;
}
.pins-pane .kg-msg-loading {
  font-size: 12px;
  opacity: 0.5;
  padding: 4px 0;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line {
  height: 10px;
  border-radius: 3px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04) 25%, rgba(255, 255, 255, 0.08) 50%, rgba(255, 255, 255, 0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 6px;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line:nth-child(1) {
  width: 90%;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line:nth-child(2) {
  width: 70%;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line:nth-child(3) {
  width: 50%;
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.pins-pane .kg-msg-excerpt {
  font-size: 12px;
  opacity: 0.6;
  line-height: 1.4;
  font-style: italic;
}
.pins-pane .kg-filter-bar {
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 8px;
  gap: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.pins-pane .kg-filter-bar .kg-filter-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.4;
}
.pins-pane .kg-filter-bar .kg-filter-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: inherit;
  font-size: 12px;
  padding: 4px 0;
}
.pins-pane .kg-filter-bar .kg-filter-input::placeholder {
  opacity: 0.4;
}
.pins-pane .kg-filter-bar .kg-filter-count {
  font-size: 11px;
  opacity: 0.5;
  white-space: nowrap;
}
.pins-pane .kg-filter-bar .kg-filter-clear {
  font-size: 14px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  opacity: 0.4;
}
.pins-pane .kg-filter-bar .kg-filter-clear:hover {
  opacity: 0.8;
}
.pins-pane .kg-no-results {
  padding: 16px 12px;
  font-size: 12px;
  opacity: 0.5;
  text-align: center;
}
.pins-pane .calendar-container {
  flex: 1;
  overflow-y: auto;
  padding: 0 4px;
}
.pins-pane .calendar-loading {
  padding: 16px;
  font-size: 12px;
  opacity: 0.5;
  text-align: center;
}
.pins-pane ::ng-deep mat-calendar {
  width: 100%;
}
.pins-pane ::ng-deep mat-calendar .mat-calendar-header {
  padding: 4px 8px 0;
}
.pins-pane ::ng-deep mat-calendar .mat-calendar-body-cell-content {
  border-radius: 4px;
}
.pins-pane ::ng-deep mat-calendar .cal-heat-1 .mat-calendar-body-cell-content {
  background: rgba(144, 202, 249, 0.15);
}
.pins-pane ::ng-deep mat-calendar .cal-heat-2 .mat-calendar-body-cell-content {
  background: rgba(144, 202, 249, 0.25);
}
.pins-pane ::ng-deep mat-calendar .cal-heat-3 .mat-calendar-body-cell-content {
  background: rgba(144, 202, 249, 0.38);
}
.pins-pane ::ng-deep mat-calendar .cal-heat-4 .mat-calendar-body-cell-content {
  background: rgba(144, 202, 249, 0.55);
}
.pins-pane .calendar-hours {
  margin-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 8px;
}
.pins-pane .calendar-day-label {
  font-size: 12px;
  font-weight: 500;
  padding: 0 4px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.pins-pane .calendar-day-label .calendar-day-total {
  font-size: 11px;
  opacity: 0.5;
  font-weight: 400;
}
.pins-pane .calendar-day-label .calendar-view-all {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: inherit;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 3px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s;
}
.pins-pane .calendar-day-label .calendar-view-all:hover {
  opacity: 1;
}
.pins-pane .calendar-hour-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3px;
}
.pins-pane .calendar-hour-grid .calendar-hour {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 2px;
  border-radius: 4px;
  font-size: 11px;
  transition: background 0.15s;
}
.pins-pane .calendar-hour-grid .calendar-hour.has-messages {
  cursor: pointer;
}
.pins-pane .calendar-hour-grid .calendar-hour.has-messages:hover {
  background: rgba(255, 255, 255, 0.12);
}
.pins-pane .calendar-hour-grid .calendar-hour[data-heat="0"] {
  opacity: 0.25;
}
.pins-pane .calendar-hour-grid .calendar-hour[data-heat="1"] {
  background: rgba(144, 202, 249, 0.08);
}
.pins-pane .calendar-hour-grid .calendar-hour[data-heat="2"] {
  background: rgba(144, 202, 249, 0.16);
}
.pins-pane .calendar-hour-grid .calendar-hour[data-heat="3"] {
  background: rgba(144, 202, 249, 0.24);
}
.pins-pane .calendar-hour-grid .calendar-hour[data-heat="4"] {
  background: rgba(144, 202, 249, 0.35);
}
.pins-pane .calendar-hour-grid .calendar-hour .calendar-hour-label {
  font-size: 10px;
}
.pins-pane .calendar-hour-grid .calendar-hour .calendar-hour-count {
  font-size: 9px;
  opacity: 0.6;
}

.presence-dot-menu {
  font-size: 12px;
  width: 12px;
  height: 12px;
  margin-right: 8px;
}

.active-agent {
  background: rgba(255, 255, 255, 0.08);
}

.menu-section-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.4;
  padding: 8px 16px 2px;
}

.combined-selector-mobile {
  display: none;
}

.combined-selector-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-transform: none;
  line-height: 1.2;
}
.combined-selector-text .agent-badge {
  font-size: 13px;
  font-weight: 500;
}
.combined-selector-text .session-name {
  font-size: 11px;
  opacity: 0.6;
}

@container heartbeat (max-width: 500px) {
  ::ng-deep app-header-chips .header-chip .chip-folder-label {
    display: none;
  }
  ::ng-deep app-header-chips .header-chip .chip-label {
    display: none;
  }
}
@container heartbeat (max-width: 600px) {
  .agent-sidebar {
    display: none !important;
  }
  .sidebar-resize-divider {
    display: none !important;
  }
  .combined-selector-mobile {
    display: flex !important;
    width: 100% !important;
    max-width: none !important;
  }
  .combined-selector-mobile ::ng-deep .mdc-button__label {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .desktop-only {
    display: none !important;
  }
  app-header-chips.desktop-only {
    display: flex !important;
  }
  .agent-tab-group ::ng-deep .mat-mdc-tab-header {
    display: none !important;
  }
  .agent-controls-inline {
    padding: 4px 40px 6px 8px;
    justify-content: flex-start;
    gap: 4px;
  }
  .agent-controls-inline button[mat-icon-button] {
    width: 40px !important;
    height: 40px !important;
  }
  .agent-controls-inline button[mat-icon-button] ::ng-deep .mat-mdc-button-touch-target {
    width: 44px !important;
    height: 44px !important;
  }
  .agent-controls-inline button[mat-icon-button] mat-icon {
    font-size: 22px !important;
    width: 22px !important;
    height: 22px !important;
  }
  .agent-controls-inline .model-select-inline {
    display: none !important;
  }
  .agent-controls-inline .usage-bars-inline {
    min-width: 48px;
    margin-left: auto;
    padding: 8px 0;
  }
  .agent-controls-inline .dm-button-mobile-hide,
  .agent-controls-inline .settings-btn-mobile-hide {
    display: none !important;
  }
  ::ng-deep app-header-chips .header-chip {
    padding: 3px 5px;
    gap: 0;
  }
  ::ng-deep app-header-chips .header-chip > span {
    display: none;
  }
  .header-bar .left.section {
    gap: 0;
    width: 100%;
  }
  .pins-pane {
    display: none !important;
  }
  .agent-tab-row .add-agent-tab-btn {
    top: 8px;
  }
  .channel-agent-badge {
    display: inline-flex !important;
  }
}
@keyframes channel-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(0.75);
  }
}
@keyframes mic-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.jump-to-latest-btn {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(30, 30, 30, 0.95);
  color: #ccc;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.15s;
}
.jump-to-latest-btn:hover {
  background: rgba(50, 50, 50, 0.95);
  color: #fff;
}
.jump-to-latest-btn .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.hands-free-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  background: radial-gradient(ellipse at center, #1a1a2e 0%, #0d0d1a 100%);
}
.hands-free-overlay .hands-free-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
}
.hands-free-overlay .hands-free-orb {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}
.hands-free-overlay .hands-free-orb .orb-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #fff;
}
.hands-free-overlay .hands-free-orb.orb-listening {
  background: radial-gradient(circle, #ef5350 0%, #c62828 100%);
  box-shadow: 0 0 40px rgba(239, 83, 80, 0.4);
  animation: orb-pulse 2s ease-in-out infinite;
}
.hands-free-overlay .hands-free-orb.orb-thinking {
  background: radial-gradient(circle, #42a5f5 0%, #1565c0 100%);
  box-shadow: 0 0 40px rgba(66, 165, 245, 0.4);
  animation: orb-spin-glow 1.5s ease-in-out infinite;
}
.hands-free-overlay .hands-free-orb.orb-speaking {
  background: radial-gradient(circle, #66bb6a 0%, #2e7d32 100%);
  box-shadow: 0 0 40px rgba(102, 187, 106, 0.4);
  animation: orb-wave 1s ease-in-out infinite;
}
.hands-free-overlay .hands-free-orb.orb-paused {
  background: radial-gradient(circle, #78909c 0%, #37474f 100%);
  box-shadow: 0 0 20px rgba(120, 144, 156, 0.3);
  animation: none;
}
.hands-free-overlay .hands-free-orb.orb-replaying {
  background: radial-gradient(circle, #ab47bc 0%, #6a1b9a 100%);
  box-shadow: 0 0 40px rgba(171, 71, 188, 0.4);
  animation: orb-wave 1s ease-in-out infinite;
}
.hands-free-overlay .hands-free-speed-toast {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 2px;
  pointer-events: none;
  z-index: 1;
  animation: speed-toast-fade 1.2s ease-out forwards;
}
@keyframes speed-toast-fade {
  0% {
    opacity: 1;
    transform: scale(1.2);
  }
  70% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}
.hands-free-overlay .hands-free-buttons {
  display: flex;
  gap: 16px;
  width: min(520px, 100% - 32px);
  margin-top: 28px;
}
.hands-free-overlay .hands-free-btn {
  flex: 1 1 0;
  min-height: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.95);
  font-size: 22px;
  font-weight: 500;
  cursor: pointer;
}
.hands-free-overlay .hands-free-btn mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.hands-free-overlay .hands-free-btn:active {
  background: rgba(255, 255, 255, 0.26);
}
.hands-free-overlay .hands-free-btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.hands-free-overlay .hands-free-btn.primary {
  background: rgba(255, 255, 255, 0.18);
}
.hands-free-overlay .hands-free-btn.primary.stop {
  background: rgba(229, 57, 53, 0.85);
  border-color: rgba(229, 57, 53, 0.9);
}
.hands-free-overlay .hands-free-speed {
  margin-top: 14px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  cursor: pointer;
}
.hands-free-overlay .hands-free-speed:active {
  background: rgba(255, 255, 255, 0.15);
}
.hands-free-overlay .hands-free-label {
  font-size: 24px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 2px;
  text-transform: uppercase;
}
.hands-free-overlay .hands-free-agent {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
}
.hands-free-overlay .hands-free-transcript {
  max-width: 80%;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-style: italic;
  line-height: 1.4;
  min-height: 56px;
  max-height: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.hands-free-overlay .hands-free-stop {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
}
.hands-free-overlay .hands-free-stop:hover, .hands-free-overlay .hands-free-stop:active {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}
.hands-free-overlay .hands-free-stop .mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

@keyframes orb-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 40px rgba(239, 83, 80, 0.4);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 60px rgba(239, 83, 80, 0.6);
  }
}
@keyframes orb-spin-glow {
  0%, 100% {
    box-shadow: 0 0 40px rgba(66, 165, 245, 0.4);
  }
  50% {
    box-shadow: 0 0 60px rgba(66, 165, 245, 0.7);
  }
}
@keyframes orb-wave {
  0%, 100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.97);
  }
}
.orchestration-panel {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
}
.orchestration-panel .orch-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.orchestration-panel .orch-title {
  font-weight: 500;
  font-size: 13px;
  opacity: 0.9;
}
.orchestration-panel .orch-select-field {
  width: 100%;
}
.orchestration-panel .orch-select-field ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  display: inline-flex;
  align-items: center;
}
.orchestration-panel .orch-scope-badge {
  font-size: 10px;
  opacity: 0.5;
  margin-left: 8px;
  text-transform: uppercase;
}
.orchestration-panel .orch-description {
  font-size: 12px;
  opacity: 0.6;
  margin: -4px 0 8px 2px;
}
.orchestration-panel .orch-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-start;
}
.orchestration-panel .orch-field {
  flex: 1;
  min-width: 140px;
  max-width: 280px;
}
.orchestration-panel .orch-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  background-color: transparent !important;
  height: 0;
  overflow: hidden;
}
.orchestration-panel .orch-field ::ng-deep .mat-mdc-form-field-infix {
  display: inline-flex;
  align-items: center;
}
.orchestration-panel .orch-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}
.orchestration-panel .orch-go-btn mat-icon {
  font-size: 18px;
  margin-right: 4px;
}
.orchestration-panel .orch-state-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  font-weight: 500;
}
.orchestration-panel .orch-state-badge.orch-state-running {
  background: rgba(33, 150, 243, 0.2);
  color: #42a5f5;
}
.orchestration-panel .orch-state-badge.orch-state-waiting {
  background: rgba(255, 152, 0, 0.2);
  color: #ffa726;
}
.orchestration-panel .orch-state-badge.orch-state-done {
  background: rgba(76, 175, 80, 0.2);
  color: #66bb6a;
}
.orchestration-panel .orch-state-badge.orch-state-error {
  background: rgba(244, 67, 54, 0.2);
  color: #ef5350;
}
.orchestration-panel .orch-state-badge.orch-state-aborted {
  background: rgba(158, 158, 158, 0.2);
  color: #9e9e9e;
}
.orchestration-panel .orch-step {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  opacity: 0.8;
  margin: 4px 0;
}
.orchestration-panel .orch-step .orch-step-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.orchestration-panel .orch-step .orch-step-icon.error {
  color: #ef5350;
}
.orchestration-panel .orch-gate {
  margin: 8px 0;
  padding: 8px 12px;
  border-left: 3px solid #ffa726;
  background: rgba(255, 152, 0, 0.05);
  border-radius: 0 4px 4px 0;
}
.orchestration-panel .orch-gate .orch-gate-prompt {
  font-size: 13px;
  margin-bottom: 8px;
}
.orchestration-panel .orch-gate .orch-gate-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.orchestration-panel .orch-gate .orch-gate-btn {
  font-size: 12px;
}
.orchestration-panel .orch-gate .orch-gate-notes {
  width: 100%;
}
.orchestration-panel .orch-gate .orch-gate-notes ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 6px;
  padding-bottom: 6px;
}

.agent-tab-row .orch-toggle-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 33px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  opacity: 0.4;
  transition: opacity 0.15s;
}
.agent-tab-row .orch-toggle-btn:hover {
  opacity: 1;
}
.agent-tab-row .orch-toggle-btn mat-icon {
  font-size: 18px;
}

.agent-tab-row .terminal-toggle-btn {
  position: absolute;
  top: 0;
  right: 64px;
  width: 32px;
  height: 33px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  opacity: 0.4;
  transition: opacity 0.15s;
}
.agent-tab-row .terminal-toggle-btn:hover {
  opacity: 1;
}
.agent-tab-row .terminal-toggle-btn.active {
  opacity: 1;
  color: #42a5f5;
}
.agent-tab-row .terminal-toggle-btn.throb {
  opacity: 1;
  animation: throb 0.6s ease-in-out 4;
}
.agent-tab-row .terminal-toggle-btn mat-icon {
  font-size: 18px;
}

.addressee-select {
  font-size: 13px;
  width: auto;
  min-width: 160px;
  max-width: 320px;
  opacity: 0.9;
  flex-shrink: 0;
  margin-right: 10px;
  padding: 0 6px;
  border-radius: 6px;
  background: rgba(128, 128, 128, 0.08);
  transition: background 0.15s;
}
.addressee-select:hover {
  background: rgba(128, 128, 128, 0.16);
}
.addressee-select .to-label {
  opacity: 0.55;
  margin-right: 7px;
}
.addressee-select .pill-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 7px;
  vertical-align: middle;
}
.addressee-select .to-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 6px;
}
.addressee-select ::ng-deep .mat-mdc-select-trigger {
  padding: 4px 4px;
  min-height: unset;
  height: 28px;
}
.addressee-select ::ng-deep .mat-mdc-select-value {
  font-size: 13px;
  color: inherit;
  overflow: visible;
}
.addressee-select ::ng-deep .mat-mdc-select-value-text {
  white-space: nowrap;
}
.addressee-select ::ng-deep .mat-mdc-select-arrow-wrapper {
  transform: scale(0.8);
}

.agent-menu .menu-check, ::ng-deep .agent-menu .menu-check {
  margin-left: auto;
  margin-right: 0;
  opacity: 0.7;
}

.agent-controls-inline .terminal-inline-btn.active {
  opacity: 1 !important;
  color: #42a5f5;
}
.agent-controls-inline .terminal-inline-btn.throb {
  opacity: 1 !important;
  animation: throb 0.6s ease-in-out 4;
}

.agent-controls-inline .power-divider {
  flex: 0 0 1px;
  height: 18px;
  margin: 0 10px 0 4px;
  background: rgba(128, 128, 128, 0.35);
}

.agent-controls-inline .orch-inline-btn {
  position: relative;
}
.agent-controls-inline .orch-inline-btn.active {
  opacity: 1 !important;
  color: #42a5f5;
}
.agent-controls-inline .orch-inline-btn .orch-badge {
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 9px;
  line-height: 1;
  padding: 1px 4px;
  border-radius: 6px;
  background: rgba(66, 165, 245, 0.85);
  color: #fff;
}

@keyframes throb {
  0%, 100% {
    transform: scale(1);
    color: inherit;
  }
  50% {
    transform: scale(1.3);
    color: #42a5f5;
  }
}
.terminal-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.terminal-view app-terminal {
  flex: 1;
  display: flex;
}
.terminal-view app-terminal ::ng-deep .content {
  flex: 1;
  display: flex;
}
.terminal-view app-terminal ::ng-deep ng-terminal {
  flex: 1;
}

.orch-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 9px;
  background: #42a5f5;
  color: white;
  border-radius: 8px;
  padding: 1px 5px;
  line-height: 1;
}

.throttle-ctx-anchor {
  position: fixed;
  width: 0;
  height: 0;
  visibility: hidden;
}

/* Pre-emptive auth banner (expired/expiring Claude login) */
.auth-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 8px 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
}
.auth-banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.auth-banner .auth-banner-text {
  flex: 1;
}
.auth-banner.warn {
  background: rgba(229, 192, 123, 0.14);
  border: 1px solid rgba(229, 192, 123, 0.45);
}
.auth-banner.error {
  background: rgba(224, 108, 117, 0.14);
  border: 1px solid rgba(224, 108, 117, 0.45);
}

/* Usage-limit card */
.limit-banner .limit-banner-select {
  max-width: 220px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: transparent;
  color: inherit;
  font: inherit;
}
.limit-banner .limit-banner-select option {
  color: initial;
}
.limit-banner .limit-banner-close {
  width: 28px;
  height: 28px;
  line-height: 28px;
  padding: 0;
}
.limit-banner .limit-banner-close mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

/* Inline re-auth flow (expanded auth banner) */
.auth-banner .auth-banner-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.auth-banner.expanded {
  border-color: var(--accent-color, #61afef);
}
.auth-banner.expanded, .auth-banner.ok {
  display: block;
}
.auth-banner .auth-reauth-flow {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 2px;
}
.auth-banner .auth-reauth-flow.ok {
  color: #98c379;
}
.auth-banner .auth-reauth-step {
  font-size: 13px;
  opacity: 0.85;
}
.auth-banner .auth-reauth-link {
  cursor: pointer;
  text-decoration: underline;
  margin-left: 6px;
}
.auth-banner .auth-reauth-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}
.auth-banner .auth-reauth-input {
  flex: 1;
  max-width: 420px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: transparent;
  color: inherit;
  font: inherit;
}
.auth-banner .auth-reauth-input:focus {
  border-color: var(--accent-color, #61afef);
  outline: none;
}
.auth-banner .auth-reauth-error {
  color: #e06c75;
  font-size: 13px;
}

/* Presence v1: "Your devices" sidebar section */
.nav-device-item {
  cursor: default;
}

.device-online-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #98c379;
  margin-left: auto;
  flex-shrink: 0;
}

.nav-device-item {
  cursor: pointer;
}

.remote-team-header {
  padding: 4px 12px 2px 28px;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.55;
}

.remote-channel-item {
  opacity: 0.85;
}

/* Remote channel view (Presence slice 3/4-lite) */
.remote-channel-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.remote-channel-view .message-area {
  flex: 1;
  min-height: 0;
}

.remote-channel-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.remote-channel-header .remote-channel-title {
  font-weight: 600;
}
.remote-channel-header .remote-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(97, 175, 239, 0.15);
  border: 1px solid rgba(97, 175, 239, 0.4);
}
.remote-channel-header .remote-header-spacer {
  flex: 1;
}

::ng-deep .model-select-panel .pool-cred {
  opacity: 0.55;
  font-size: 0.85em;
}

.pin-count-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.pin-count-chip .pin-count {
  font-size: 11px;
  opacity: 0.8;
}

/* ── Conversations with other people's agents (standing orders) ─────────── */
.nav-guest-header {
  margin-top: 10px;
}

.nav-guest-item .nav-guest-icon {
  color: #7fb4ff;
}

.guest-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}
.guest-strip .guest-strip-icon {
  color: #7fb4ff;
  flex: none;
}
.guest-strip .guest-strip-text {
  min-width: 0;
  flex: 1;
}
.guest-strip .guest-strip-title {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.guest-strip .guest-strip-state {
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: rgba(244, 172, 57, 0.18);
  color: #f4ac39;
}
.guest-strip .guest-strip-about {
  font-size: 12px;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.guest-strip .guest-strip-notice {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: none;
  max-width: 46%;
  font-size: 12px;
  opacity: 0.75;
}
.guest-strip .guest-strip-notice mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex: none;
}

.guest-composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 10px 14px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}
.guest-composer .guest-input {
  flex: 1;
  min-height: 44px;
  max-height: 30vh;
  resize: vertical;
  padding: 10px 14px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.04);
  color: inherit;
  font: inherit;
  outline: none;
}
.guest-composer .guest-input:focus {
  border-color: #7fb4ff;
}
.guest-composer .guest-input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.affinity-select-inline {
  max-width: 220px;
}

.aff-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: 1px;
}
.aff-dot.alive {
  background: #4caf50;
  box-shadow: 0 0 4px rgba(76, 175, 80, 0.7);
}
.aff-dot.off {
  background: #9e9e9e;
}

.aff-home {
  padding: 6px 16px 8px;
  font-size: 12px;
  opacity: 0.7;
  border-top: 1px solid rgba(128, 128, 128, 0.25);
  margin-top: 4px;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/heartbeat-widget/heartbeat-widget.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;AAEF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAAF;;AAIA;EACE,UAAA;EACA,iBAAA;EACA,6BAAA;EACA,yDAAA;EACA,cAAA;AADF;AAGE;EACE,2CAAA;AADJ;AAIE;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AAFJ;AAII;EACE,UAAA;EACA,UAAA;AAFN;;AAQA;EACE,OAAA;EACA,gBAAA;EACA,cAAA;AALF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AANF;AAQE;EACE,eAAA;EACA,+CAAA;EACA,gBAAA;AANJ;AASE;EACE,qCAAA;AAPJ;AAUE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;AARJ;;AAYA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EAKA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbF;AAQE;EACE,iBAAA;AANJ;AAYE;EACE,WAAA;EACA,YAAA;AAVJ;AAaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAXJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AAbF;AAeE;EACE,qCAAA;AAbJ;AAgBE;EACE,+CAAA;AAdJ;AAgBI;EACE,yBAAA;EACA,qBAAA;AAdN;AAiBI;EACE,2BAAA;AAfN;AAmBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlBJ;;AAyBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAtBF;AAwBE;EACE,mBAAA;EACA,kDAAA;AAtBJ;AAyBE;EACE,mBAAA;AAvBJ;;AAgCE;EACE,+CAAA;AA7BJ;AA+BI;EAAqB,UAAA;AA5BzB;AA6BI;EAAgB,UAAA;EAAY,gBAAA;AAzBhC;AA4BE;EACE,cAAA;EACA,aAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,OAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,kBAAA;AA7BJ;;AAmCA;EACE,wBAAA;AAhCF;;AAmCA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAhCF;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,kDAAA;AAhCJ;AAkCI;EAAuB,cAAA;EAAgB,eAAA;EAAiB,WAAA;EAAa,YAAA;AA5BzE;AA6BI;EAAwB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AAtBzG;AAuBI;EAAuB,eAAA;EAAiB,YAAA;EAAc,mBAAA;EAAqB,OAAA;EAAS,gBAAA;EAAkB,uBAAA;AAf1G;AAkBE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAkBI;EAAU,eAAA;EAAiB,YAAA;AAd/B;AAiBE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;AAfJ;AAiBI;EAAmB,cAAA;EAAgB,UAAA;AAbvC;AAgBE;EAAgB,OAAA;EAAS,aAAA;AAZ3B;;AAgBA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAbF;AAeE;EACE,qBAAA;EACA,qCAAA;AAbJ;;AAiBA;EACE,aAAA;AAdF;;AAkBA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,qCAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AAfF;AAiBE;EACE,qCAAA;AAfJ;AAkBE;EACE,+CAAA;AAhBJ;AAkBI;EAAe,cAAA;EAAgB,UAAA;AAdnC;AAeI;EAAgB,UAAA;EAAY,gBAAA;AAXhC;AAcE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAZJ;AAcI;EACE,cAAA;EACA,YAAA;AAZN;AAgBE;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,OAAA;EACA,YAAA;AAdJ;;AAkBA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAfF;;AAmBA;EACE,UAAA;AAhBF;;AAmBA;EACE,UAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,4BAAA;AAhBF;AAkBE;EACE,qCAAA;AAhBJ;AAmBE;EACE,+CAAA;AAjBJ;AAmBI;EACE,2BAAA;AAjBN;AAqBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;AAnBJ;AAqBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnBN;AAsBI;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApBN;AAwBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,YAAA;AAtBN;AAyBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAvBN;AA0BI;EACE,cAAA;AAxBN;AA2BI;EACE,cAAA;AAzBN;AA4BI;EACE,cAAA;EACA,kDAAA;AA1BN;AA6BI;EACE,UAAA;AA3BN;AA+BE;EACE,YAAA;AA7BJ;AA+BI;EACE,UAAA;AA7BN;;AAkCA;EACE;IAAW,UAAA;EA9BX;EA+BA;IAAM,YAAA;EA5BN;AACF;AA+BA;EACE,aAAA;EACA,8BAAA;AA7BF;AA+BE;EACE,YAAA;AA7BJ;;AAkCA;EACE,0BAAA;EACA,wBAAA;EAEA,gCAAA;EACA,iCAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhCF;AAkCE;EACE,8BAAA;EACA,+BAAA;EACA,oCAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhCJ;AAmCE;EACE,qBAAA;AAjCJ;AAoCE;EACE,gCAAA;EACA,iCAAA;AAlCJ;;AAuCA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AApCF;;AAwCA;EACE,kBAAA;AArCF;AAuCE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AArCJ;AAuCI;EACE,UAAA;AArCN;AAyCM;;;;EAIE,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAvCR;AA2CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAzCN;;AA8CA;EAEE,qDAAA;AA5CF;AAkDI;EAAsB,wBAAA;AA/C1B;AAiDI;EACE,iDAAA;AA/CN;AAkDI;EACE,MAAA;EACA,mBAAA;AAhDN;AAmDI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,iDAAA;AAjDN;AAoDM;EACE,wCAAA;AAlDR;AAqDM;EAAU,uBAAA;AAlDhB;AAoDM;EACE,qBAAA;EACA,gBAAA;AAlDR;AAoDQ;EACE,gBAAA;AAlDV;AAsDM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AApDR;AAyDI;EACE,0DAAA;EACA,gEAAA;EACA,gEAAA;EACA,0DAAA;AAvDN;AAyDM;EACE,gCAAA;EACA,iDAAA;EACA,qDAAA;AAvDR;AA4DI;EACE,UAAA;AA1DN;AA6DI;EACE,iBAAA;AA3DN;;AAmEI;EACE,0CAAA;AAhEN;AAmEI;EACE,sDAAA;AAjEN;AAmEM;EACE,sBAAA;AAjER;;AAyEI;EACE,qCAAA;AAtEN;AAyEI;EACE,gDAAA;AAvEN;AAyEM;EACE,qCAAA;AAvER;;AA6EA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AA1EF;AA4EE;EACE,UAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,sBAAA;AA3EF;;AA8EA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;AA3EF;AA6EE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AA3EJ;AA6EI;EAAU,aAAA;AA1Ed;AA4EI;EACE,WAAA;EACA,YAAA;AA1EN;AA6EI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3EN;AA8EI;EACE,UAAA;EAEA,8CAAA;AA7EN;AA4EM;EAAW,cAAA;AAzEjB;AA6EI;EAAqB,UAAA;AA1EzB;AA0EqC;EAAW,cAAA;AAvEhD;AAwEI;EAAqB,UAAA;AArEzB;AAqEqC;EAAW,cAAA;AAlEhD;AAmEI;EAAyB,UAAA;AAhE7B;AAgEyC;EAAW,cAAA;EAAgB,kDAAA;AA5DpE;;AAiEA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EAGA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AAhEF;AAkEE;EAAU,aAAA;AA/DZ;AAkEI;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;AAhEN;AAkEI;EACE,eAAA;EACA,cAAA;AAhEN;AAkEI;EACE,sBAAA;AAhEN;;AAqEA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAlEF;AAoEE;EACE,YAAA;EACA,iBAAA;AAlEJ;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAGA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,WAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,2BAAA;EACA,kBAAA;AAxEF;AA0EE;EAAiB,mBAAA;AAvEnB;AAwEE;EAAkB,mBAAA;AArEpB;AAsEE;EAAmB,mBAAA;AAnErB;;AAsEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;AAnEF;AAqEE;EACE,UAAA;AAnEJ;;AAuEA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;AApEF;AAsEE;EACE,aAAA;AApEJ;AAuEE;EACE,WAAA;EACA,YAAA;AArEJ;AAwEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtEJ;;AA0EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;AAvEF;AAyEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAvEJ;AAyEI;EACE,OAAA;EACA,gBAAA;AAvEN;AA0EI;EACE,iBAAA;EACA,cAAA;AAxEN;AA2EI;EACE,cAAA;AAzEN;AA8EM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AA5ER;AA8EQ;EAAU,aAAA;AA3ElB;AA6EQ;EACE,WAAA;EACA,YAAA;AA3EV;AA8EQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5EV;AA+EQ;EACE,UAAA;EAEA,8CAAA;AA9EV;AA6EU;EAAW,cAAA;AA1ErB;AA8EQ;EAAqB,UAAA;AA3E7B;AA2EyC;EAAW,cAAA;AAxEpD;AAyEQ;EAAqB,UAAA;AAtE7B;AAsEyC;EAAW,cAAA;AAnEpD;AAoEQ;EAAyB,UAAA;AAjEjC;AAiE6C;EAAW,cAAA;EAAgB,kDAAA;AA7DxE;AAkEE;EACE,YAAA;AAhEJ;AAiEI;EAAU,UAAA;AA9Dd;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AA/DJ;AAiEI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;AA/DN;AAgEM;EAAU,qCAAA;AA7DhB;AAiEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AA/DJ;AAiEI;EACE,0CAAA;AA/DN;AAmEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAlEJ;;AAsEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;AAnEF;AAqEE;EACE,UAAA;EACA,qCAAA;AAnEJ;AAsEE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AApEJ;AAuEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AArEJ;;AA0EA;EACE,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,2DAAA;AAvEF;AAyEE;EACE,YAAA;EACA,2CAAA;AAvEJ;AA0EE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxEJ;AA0EI;EACE,kCAAA;AAxEN;AA4EE;EACE,2CAAA;AA1EJ;;AA+EE;;EAEE,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AA5EJ;AA+EE;EACE,WAAA;EACA,cAAA;AA7EJ;AAgFE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;AA9EJ;AAgFI;EAAa,eAAA;AA7EjB;AAgFE;EACE,YAAA;AA9EJ;AA+EI;EAAyB,UAAA;AA5E7B;AA6EI;EAAa,YAAA;AA1EjB;AA6EE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AA3EJ;AA4EI;EAAU,UAAA;AAzEd;;AA8EE;;EAEE,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AA3EJ;AA8EE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AA5EJ;AA+EE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AA7EJ;AAgFE;EACE,WAAA;EACA,cAAA;AA9EJ;AAiFE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;AA/EJ;AAgFI;EAAa,eAAA;AA7EjB;AAgFE;EACE,YAAA;AA9EJ;AA+EI;EAAyB,UAAA;AA5E7B;AA6EI;EAAa,YAAA;AA1EjB;AA6EE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AA3EJ;AA4EI;EAAU,UAAA;AAzEd;;AA8EA;EACE,OAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE;IAAW,UAAA;EA1EX;EA2EA;IAAM,YAAA;EAxEN;AACF;AA2EA;EACE,kDAAA;AAzEF;;AA4EA;EACE;IAAW,0CAAA;EAxEX;EAyEA;IAAM,0CAAA;EAtEN;AACF;AAyEA;EACE,0CAAA;AAvEF;;AA0EA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAvEF;AAyEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAvEJ;AA0EE;EACE,eAAA;AAxEJ;;AA6EA;EACE,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,uCAAA;EACA,cAAA;EACA,8CAAA;AA1EF;AA4EE;EACE,2CAAA;AA1EJ;;AA8EA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA3EF;AA+EI;EACE,yBAAA;EACA,aAAA;AA7EN;AAgFI;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AA9EN;AAiFI;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AA/EN;AAmFE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAjFJ;AAoFE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAlFJ;AAqFE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAnFJ;AAuFM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AArFR;AAwFM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAtFR;AAyFM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAvFR;AA0FM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAxFR;AA2FM;EACE,cAAA;EACA,oBAAA;EACA,aAAA;EACA,gBAAA;AAzFR;AA4FM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AA1FR;AA6FM;EACE,cAAA;EACA,2BAAA;EACA,YAAA;EACA,2BAAA;AA3FR;;AAkGA;EACE,UAAA;EACA,iBAAA;EACA,0DAAA;EACA,uCAAA;EACA,cAAA;AA/FF;AAiGE;EACE,+CAAA;EACA,YAAA;AA/FJ;;AAoGA;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,gDAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAjGF;AAmGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,kDAAA;AAjGJ;AAmGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAjGN;AAoGI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlGN;AAqGI;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AAnGN;AAsGI;EAAe,OAAA;AAnGnB;AAsGE;EACE,aAAA;EACA,cAAA;EACA,QAAA;EACA,kDAAA;AApGJ;AAsGI;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;EACA,6CAAA;AApGN;AAsGM;EAAU,YAAA;AAnGhB;AAqGM;EACE,UAAA;EACA,6CAAA;AAnGR;AAwGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,kDAAA;AAtGJ;AAwGI;EACE,OAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAtGN;AAwGM;EAAU,uCAAA;AArGhB;AAsGM;EAAiB,YAAA;AAnGvB;AAuGM;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AArGR;AAwGM;EAAwB,UAAA;EAAY,cAAA;AApG1C;AAwGE;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AAtGJ;AAyGE;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AAvGJ;AAyGI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAvGN;AAyGM;EACE,YAAA;AAvGR;AA4GE;EACE,OAAA;EACA,gBAAA;EACA,cAAA;AA1GJ;AA6GE;EACE,kBAAA;AA3GJ;AA6GI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AA3GN;AA6GM;EAAmB,cAAA;AA1GzB;AA2GM;EAAoB,gBAAA;EAAkB,OAAA;AAvG5C;AA0GI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;AAxGN;AA0GM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxGR;AA2GM;EACE,eAAA;EACA,YAAA;AAzGR;AA4GM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,+BAAA;AA1GR;AA8GI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AA5GN;AA8GM;EAAU,UAAA;AA3GhB;AA8GI;EACE,eAAA;EACA,4BAAA;AA5GN;AA8GM;EACE,qCAAA;AA5GR;AA8GQ;EAAgB,UAAA;AA3GxB;AA+GI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mEAAA;EACA,2EAAA;AA7GN;AAgHQ;EAAiB,eAAA;EAAiB,aAAA;AA5G1C;AA6GQ;EAAI,aAAA;AA1GZ;AA2GQ;EAAM,eAAA;EAAiB,YAAA;EAAc,gBAAA;AAtG7C;AAuGQ;EAAS,kBAAA;EAAoB,aAAA;AAnGrC;AAoGQ;EAAO,eAAA;AAjGf;AAkGQ;EAAmB,cAAA;AA/F3B;AAoGE;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAlGJ;AAqGM;EACE,YAAA;EACA,kBAAA;EACA,+HAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;AAnGR;AAqGQ;EAAiB,UAAA;AAlGzB;AAmGQ;EAAiB,UAAA;AAhGzB;AAiGQ;EAAiB,UAAA;AA9FzB;AAkGI;EACE;IAAK,2BAAA;EA/FT;EAgGI;IAAO,4BAAA;EA7FX;AACF;AAgGE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,kDAAA;AA/FJ;AAiGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA/FN;AAkGI;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAhGN;AAkGM;EAAiB,YAAA;AA/FvB;AAkGI;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AAhGN;AAmGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAjGN;AAmGM;EAAU,YAAA;AAhGhB;AAoGE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAlGJ;AAsGE;EACE,OAAA;EACA,gBAAA;EACA,cAAA;AApGJ;AAuGE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AArGJ;AAwGE;EACE,WAAA;AAtGJ;AAwGI;EACE,kBAAA;AAtGN;AAyGI;EACE,kBAAA;AAvGN;AA0GI;EACE,qCAAA;AAxGN;AA0GI;EACE,qCAAA;AAxGN;AA0GI;EACE,qCAAA;AAxGN;AA0GI;EACE,qCAAA;AAxGN;AA4GE;EACE,gBAAA;EACA,+CAAA;EACA,gBAAA;AA1GJ;AA6GE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA3GJ;AA6GI;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AA3GN;AA8GI;EACE,gBAAA;EACA,2CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AA5GN;AA6GM;EAAU,UAAA;AA1GhB;AA8GE;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AA5GJ;AA8GI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AA5GN;AA8GM;EACE,eAAA;AA5GR;AA6GQ;EAAU,qCAAA;AA1GlB;AA6GM;EAAmB,aAAA;AA1GzB;AA2GM;EAAmB,qCAAA;AAxGzB;AAyGM;EAAmB,qCAAA;AAtGzB;AAuGM;EAAmB,qCAAA;AApGzB;AAqGM;EAAmB,qCAAA;AAlGzB;AAoGM;EAAuB,eAAA;AAjG7B;AAkGM;EAAuB,cAAA;EAAgB,YAAA;AA9F7C;;AAoGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjGF;;AAoGA;EACE,qCAAA;AAjGF;;AAqGA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;AAlGF;;AAsGA;EACE,aAAA;AAnGF;;AAsGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AAnGF;AAqGE;EACE,eAAA;EACA,gBAAA;AAnGJ;AAsGE;EACE,eAAA;EACA,YAAA;AApGJ;;AA6GA;EACE;IACE,aAAA;EA1GF;EA6GA;IACE,aAAA;EA3GF;AACF;AA+GA;EAEE;IACE,wBAAA;EA9GF;EAkHA;IACE,wBAAA;EAhHF;EAoHA;IACE,wBAAA;IACA,sBAAA;IACA,0BAAA;EAlHF;EAqHE;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EAnHJ;EAwHA;IACE,wBAAA;EAtHF;EA0HA;IACE,wBAAA;EAxHF;EA4HA;IACE,wBAAA;EA1HF;EA8HA;IACE,yBAAA;IACA,2BAAA;IACA,QAAA;EA5HF;EA+HE;IACE,sBAAA;IACA,uBAAA;EA7HJ;EA+HI;IACE,sBAAA;IACA,uBAAA;EA7HN;EAgII;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;EA9HN;EAmIE;IACE,wBAAA;EAjIJ;EAqIE;IACE,eAAA;IACA,iBAAA;IACA,cAAA;EAnIJ;EAwIE;;IAEE,wBAAA;EAtIJ;EA0IA;IACE,gBAAA;IACA,MAAA;EAxIF;EA0IE;IACE,aAAA;EAxIJ;EA4IA;IACE,MAAA;IACA,WAAA;EA1IF;EA8IA;IACE,wBAAA;EA5IF;EAgJA;IACE,QAAA;EA9IF;EAkJA;IACE,+BAAA;EAhJF;AACF;AAoJA;EACE;IAAW,UAAA;IAAY,mBAAA;EAhJvB;EAiJA;IAAM,aAAA;IAAe,sBAAA;EA7IrB;AACF;AA+IA;EACE;IAAW,UAAA;EA5IX;EA6IA;IAAM,YAAA;EA1IN;AACF;AA4IA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,wCAAA;EACA,qBAAA;AA1IF;AA4IE;EACE,kCAAA;EACA,WAAA;AA1IJ;AA6IE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3IJ;;AAgJA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,wEAAA;AA7IF;AA+IE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA7IJ;AAgJE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AA9IJ;AAgJI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA9IN;AAiJI;EACE,6DAAA;EACA,2CAAA;EACA,4CAAA;AA/IN;AAkJI;EACE,6DAAA;EACA,4CAAA;EACA,kDAAA;AAhJN;AAmJI;EACE,6DAAA;EACA,6CAAA;EACA,2CAAA;AAjJN;AAoJI;EACE,6DAAA;EACA,6CAAA;EACA,eAAA;AAlJN;AAqJI;EACE,6DAAA;EACA,4CAAA;EACA,2CAAA;AAnJN;AAuJE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,kDAAA;AArJJ;AAwJE;EACE;IAAK,UAAA;IAAY,qBAAA;EApJnB;EAqJE;IAAM,UAAA;IAAY,mBAAA;EAjJpB;EAkJE;IAAO,UAAA;IAAY,qBAAA;EA9IrB;AACF;AAiJE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;AA/IJ;AAkJE;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAhJJ;AAiJI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AA5I7C;AA6II;EAAW,qCAAA;AA1If;AA2II;EAAa,aAAA;EAAe,eAAA;AAvIhC;AAwII;EAAY,qCAAA;AArIhB;AAsII;EACE,mCAAA;EACA,oCAAA;AApIN;AAwIE;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0CAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;AAtIJ;AAuII;EAAW,qCAAA;AApIf;AAuIE;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,yBAAA;AArIJ;AAwIE;EACE,eAAA;EACA,+BAAA;AAtIJ;AAyIE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAvIJ;AA0IE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,qCAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAxIJ;AA0II;EACE,qCAAA;EACA,WAAA;AAxIN;AA2II;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzIN;;AA8IA;EACE;IAAW,mBAAA;IAAqB,2CAAA;EAzIhC;EA0IA;IAAM,sBAAA;IAAwB,2CAAA;EAtI9B;AACF;AAwIA;EACE;IAAW,4CAAA;EArIX;EAsIA;IAAM,4CAAA;EAnIN;AACF;AAqIA;EACE;IAAW,mBAAA;EAlIX;EAmIA;IAAM,sBAAA;EAhIN;EAiIA;IAAM,sBAAA;EA9HN;AACF;AAiIA;EACE,+CAAA;EACA,kBAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;AA/HF;AAiIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA/HJ;AAkIE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAhIJ;AAoIE;EACE,WAAA;AAlIJ;AAmII;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAjIN;AAqIE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AAnIJ;AAsIE;EACE,eAAA;EACA,YAAA;EACA,sBAAA;AApIJ;AAuIE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AArIJ;AAwIE;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;AAtIJ;AAuII;EACE,wCAAA;EACA,SAAA;EACA,gBAAA;AArIN;AAuII;EACE,oBAAA;EACA,mBAAA;AArIN;AAyIE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAvIJ;AA2II;EAAW,eAAA;EAAiB,iBAAA;AAvIhC;AA0IE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAxIJ;AA0II;EAAuB,mCAAA;EAAqC,cAAA;AAtIhE;AAuII;EAAuB,kCAAA;EAAoC,cAAA;AAnI/D;AAoII;EAAoB,kCAAA;EAAoC,cAAA;AAhI5D;AAiII;EAAqB,kCAAA;EAAoC,cAAA;AA7H7D;AA8HI;EAAuB,oCAAA;EAAsC,cAAA;AA1HjE;AA6HE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AA3HJ;AA6HI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3HN;AA4HM;EAAU,cAAA;AAzHhB;AA6HE;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mCAAA;EACA,0BAAA;AA3HJ;AA6HI;EACE,eAAA;EACA,kBAAA;AA3HN;AA8HI;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;AA5HN;AA+HI;EACE,eAAA;AA7HN;AAgII;EACE,WAAA;AA9HN;AA+HM;EAAsC,gBAAA;EAAkB,mBAAA;AA3H9D;;AAgIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AA7HF;AA8HE;EAAU,UAAA;AA3HZ;AA4HE;EAAW,eAAA;AAzHb;;AA4HA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAzHF;AA0HE;EAAU,UAAA;AAvHZ;AAwHE;EAAW,UAAA;EAAY,cAAA;AApHzB;AAqHE;EACE,UAAA;EACA,mCAAA;AAnHJ;AAqHE;EAAW,eAAA;AAlHb;;AAsHA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,4BAAA;AAnHF;AAoHE;EAAU,qCAAA;AAjHZ;AAmHE;EAAY,aAAA;EAAe,iBAAA;AA/G7B;AAgHE;EAAY,qBAAA;EAAuB,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,iBAAA;EAAmB,sBAAA;AAxGrG;AAyGE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,sBAAA;EAAwB,iBAAA;AAlGjF;AAqGI;EAA0B,gBAAA;EAAkB,iBAAA;EAAmB,YAAA;AAhGnE;AAiGI;EAAwB,eAAA;EAAiB,cAAA;EAAgB,iBAAA;AA5F7D;AA6FI;EAA6B,mBAAA;AA1FjC;AA2FI;EAAgC,qBAAA;AAxFpC;;AA4FA;EAA6D,iBAAA;EAAmB,eAAA;EAAiB,YAAA;AAtFjG;;AAyFE;EAAW,qBAAA;EAAuB,cAAA;AApFpC;AAqFE;EAAU,qBAAA;EAAuB,mCAAA;AAjFnC;;AAwFA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,qCAAA;AArFF;;AAwFA;EACE,kBAAA;AArFF;AAsFE;EAAW,qBAAA;EAAuB,cAAA;AAlFpC;AAmFE;EAAc,kBAAA;EAAoB,SAAA;EAAW,WAAA;EAAa,cAAA;EAAgB,cAAA;EAAgB,gBAAA;EAAkB,kBAAA;EAAoB,oCAAA;EAAsC,WAAA;AAxExK;;AA2EA;EACE;IAAW,mBAAA;IAAqB,cAAA;EAtEhC;EAuEA;IAAM,qBAAA;IAAuB,cAAA;EAnE7B;AACF;AAqEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAnEF;AAqEE;EACE,OAAA;EACA,aAAA;AAnEJ;AAoEI;EACE,OAAA;EACA,aAAA;AAlEN;AAoEI;EACE,OAAA;AAlEN;;AAuEA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AApEF;;AAyEA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AAtEF;;AAyEA,4DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAtEF;AAwEE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AAnE3C;AAoEE;EAAoB,OAAA;AAjEtB;AAmEE;EACE,qCAAA;EACA,2CAAA;AAjEJ;AAmEE;EACE,qCAAA;EACA,2CAAA;AAjEJ;;AAqEA,qBAAA;AAEE;EACE,gBAAA;EAAkB,gBAAA;EAAkB,kBAAA;EACpC,2CAAA;EACA,uBAAA;EAAyB,cAAA;EAAgB,aAAA;AA/D7C;AAgEI;EAAS,cAAA;AA7Db;AA+DE;EACE,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,UAAA;AA1DlD;AA2DI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AAtD7C;;AA0DA,+CAAA;AAEE;EAAmB,aAAA;EAAe,mBAAA;EAAqB,QAAA;AArDzD;AAsDE;EAAa,0CAAA;AAnDf;AAoDE;EAAmB,cAAA;AAjDrB;AAmDE;EACE,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,gBAAA;AA9CrD;AA+CI;EAAO,cAAA;AA5CX;AA8CE;EAAoB,eAAA;EAAiB,aAAA;AA1CvC;AA2CE;EAAoB,eAAA;EAAiB,0BAAA;EAA4B,gBAAA;AAtCnE;AAuCE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,QAAA;AAlC5D;AAmCE;EACE,OAAA;EAAS,gBAAA;EACT,iBAAA;EAAmB,kBAAA;EACnB,2CAAA;EACA,uBAAA;EAAyB,cAAA;EAAgB,aAAA;AA7B7C;AA8BI;EAAU,0CAAA;EAA4C,aAAA;AA1B1D;AA4BE;EAAqB,cAAA;EAAgB,eAAA;AAxBvC;;AA2BA,gDAAA;AACA;EAAmB,eAAA;AAvBnB;;AAwBA;EACE,UAAA;EAAY,WAAA;EAAa,kBAAA;EACzB,mBAAA;EACA,iBAAA;EACA,cAAA;AAnBF;;AAsBA;EAAmB,eAAA;AAlBnB;;AAmBA;EACE,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AAhBF;;AAkBA;EAAuB,aAAA;AAdvB;;AAgBA,kDAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AAbF;AAeE;EAAgB,OAAA;EAAS,aAAA;AAX3B;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kDAAA;AAVF;AAYE;EAAwB,gBAAA;AAT1B;AAUE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,yCAAA;AARJ;AAUE;EAAwB,OAAA;AAP1B;;AAaA;EACE,aAAA;EACA,iBAAA;AAVF;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAXF;AAaE;EACE,eAAA;EACA,YAAA;AAXJ;;AAgBA,8EAAA;AAEA;EAAoB,gBAAA;AAbpB;;AAcA;EAAkC,cAAA;AAVlC;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kDAAA;EACA,cAAA;AATF;AAWE;EAAoB,cAAA;EAAgB,UAAA;AAPtC;AAQE;EAAoB,YAAA;EAAc,OAAA;AAJpC;AAKE;EAAqB,gBAAA;EAAkB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AAChF;AAAE;EACE,gBAAA;EAAkB,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAC1E,oCAAA;EAAsC,cAAA;AAO1C;AALE;EAAqB,eAAA;EAAiB,YAAA;EAAc,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AAY7F;AAXE;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,UAAA;EAAY,cAAA;EAC1D,eAAA;EAAiB,aAAA;AAkBrB;AAjBI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,UAAA;AAuB3D;;AAnBA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,uBAAA;EACA,+CAAA;EACA,cAAA;AAsBF;AApBE;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,qCAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AAsBJ;AApBI;EAAU,qBAAA;AAuBd;AAtBI;EAAa,aAAA;EAAe,mBAAA;AA0BhC;;AArBA;EACE,gBAAA;AAwBF;;AAtBA;EACE,qBAAA;EAAuB,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,iBAAA;EAAmB,mBAAA;AA8BzF;AA7BE;EAAU,mBAAA;EAAqB,0CAAA;AAiCjC;AAhCE;EAAQ,mBAAA;AAmCV;;AAjCA;EACE,qBAAA;EAAuB,eAAA;EAAiB,YAAA;EAAc,+CAAA;EAAiD,eAAA;EAAiB,eAAA;AAyC1H","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--preset-card);\n  border-radius: 4px;\n}\n\n.heartbeat-container {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  container-type: inline-size;\n  container-name: heartbeat;\n}\n\n// --- Presence dot (shared) ---\n.presence-dot {\n  font-size: 12px;\n  width: 12px;\n  height: 12px;\n  min-width: 12px;\n  overflow: visible;\n  transition: color 0.3s;\n}\n\n// --- Sidebar ---\n.agent-sidebar {\n  flex-shrink: 0;\n  min-width: 150px;\n  max-width: 400px;\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Resize divider (mirrors chat-widget)\n.sidebar-resize-divider {\n  width: 4px;\n  cursor: ew-resize;\n  background-color: transparent;\n  transition: background-color 0.15s ease, width 0.15s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: rgba(128, 128, 128, 0.35);\n  }\n\n  &.collapsed {\n    width: 6px;\n    cursor: e-resize;\n    opacity: 0.7;\n\n    &:hover {\n      width: 8px;\n      opacity: 1;\n    }\n  }\n}\n\n// --- Navigation tree ---\n.nav-tree {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n// Collapsible section headers (MY CHANNELS, DM)\n.nav-section-header {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px 2px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s;\n\n  &:not(:first-child) {\n    margin-top: 4px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    padding-top: 8px;\n  }\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.04);\n  }\n\n  .nav-section-title {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    opacity: 0.6;\n    flex: 1;\n  }\n}\n\n.nav-expand-icon {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  opacity: 0.5;\n  margin-right: 2px;\n}\n\n.nav-add-btn {\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  opacity: 0.6;\n  transition: opacity 0.15s;\n\n  &:first-of-type {\n    margin-left: auto;\n  }\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: 20px;\n    height: 20px;\n  }\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    line-height: 14px;\n  }\n}\n\n// Channel items\n.nav-channel-item {\n  display: flex;\n  align-items: center;\n  padding: 3px 10px 3px 14px;\n  margin: 1px 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s;\n  min-height: 28px;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  &.selected {\n    background: rgba(244, 172, 57, 0.12) !important;\n\n    .nav-channel-icon {\n      color: #f4ac39 !important;\n      opacity: 1 !important;\n    }\n\n    .nav-channel-name {\n      font-weight: 600 !important;\n    }\n  }\n\n  .nav-channel-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    min-width: 14px;\n    opacity: 0.5;\n    margin-right: 6px;\n  }\n\n  .nav-channel-name {\n    font-size: 13px;\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n}\n\n// Activity dots: busy (blue, pulsing) and a reply waiting (green). Shared by\n// channel rows, the rows nested under them and the background-agent strip.\n.channel-activity-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-right: 4px;\n\n  &.streaming {\n    background: #64b5f6;\n    animation: channel-pulse 1.2s ease-in-out infinite;\n  }\n\n  &.unread {\n    background: #81c784;\n  }\n}\n\n// Work session items (nested under channels)\n// A background agent's row: same indent as a child channel, its own icon, a\n// live dot, and elapsed time. Not a channel — it comes and goes with the agent.\n.nav-bg-agent-item {\n  // Its stream is open: the row is the selection, not the channel above it.\n  &.selected {\n    background: rgba(244, 172, 57, 0.12) !important;\n\n    .nav-bg-agent-icon { opacity: 1; }\n    .nav-ws-title { opacity: 1; font-weight: 600; }\n  }\n\n  .nav-bg-agent-icon {\n    color: #f4ac39;\n    opacity: 0.85;\n  }\n\n  .nav-ws-title {\n    font-style: italic;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .nav-bg-agent-elapsed {\n    font-size: 10px;\n    opacity: 0.55;\n    margin: 0 6px;\n    white-space: nowrap;\n  }\n\n  &.nav-bg-agent-nested {\n    padding-left: 46px;\n  }\n}\n\n// Background-agent stream: covers the channel view below the channel bar.\n// The channel's own blocks are hidden, not destroyed (composer draft, scroll).\n.main-area.bg-agent-open > :not(.header-bar):not(.bg-agent-view) {\n  display: none !important;\n}\n\n.bg-agent-view {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n\n  .bg-agent-strip {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 12px 4px 4px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n    .bg-agent-strip-icon { color: #f4ac39; font-size: 18px; width: 18px; height: 18px; }\n    .bg-agent-strip-title { font-weight: 600; font-style: italic; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n    .bg-agent-strip-meta { font-size: 12px; opacity: 0.6; white-space: nowrap; flex: 1; overflow: hidden; text-overflow: ellipsis; }\n  }\n\n  .bg-agent-task {\n    margin: 8px 14px 0;\n    padding: 6px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 6px;\n    font-size: 13px;\n    max-height: 40%;\n    overflow: auto;\n\n    summary { cursor: pointer; opacity: 0.7; }\n  }\n\n  .bg-agent-note {\n    margin: 8px 14px 0;\n    font-size: 12px;\n    opacity: 0.6;\n\n    &.bg-agent-error { color: #e57373; opacity: 1; }\n  }\n\n  .message-area { flex: 1; min-height: 0; }\n}\n\n// Hover \"+\" on a channel row: create a channel under it.\n.nav-channel-item .nav-add-child {\n  margin-left: auto;\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  opacity: 0;\n  border-radius: 4px;\n  transition: opacity 0.15s;\n\n  &:hover {\n    opacity: 1 !important;\n    background: rgba(255, 255, 255, 0.12);\n  }\n}\n\n.nav-channel-item:hover .nav-add-child {\n  opacity: 0.55;\n}\n\n// The name row for a channel being created (top-level, or under a channel).\n.nav-channel-draft input {\n  flex: 1;\n  min-width: 0;\n  font: inherit;\n  font-size: 12px;\n  color: inherit;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(244, 172, 57, 0.5);\n  border-radius: 4px;\n  padding: 2px 6px;\n  outline: none;\n}\n\n.nav-work-session-item {\n  display: flex;\n  align-items: center;\n  padding: 2px 10px 2px 30px; // Indented under channel\n  margin: 0 6px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s;\n  min-height: 24px;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  &.selected {\n    background: rgba(244, 172, 57, 0.12) !important;\n\n    .nav-ws-icon { color: #f4ac39; opacity: 1; }\n    .nav-ws-title { opacity: 1; font-weight: 600; }\n  }\n\n  .nav-ws-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    min-width: 13px;\n    opacity: 0.4;\n    margin-right: 6px;\n\n    &.ws-active {\n      color: #4caf50;\n      opacity: 0.8;\n    }\n  }\n\n  .nav-ws-title {\n    font-size: 12px;\n    opacity: 0.7;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;       // pushes the activity dot to the right edge, as on channel rows\n    min-width: 0;\n  }\n}\n\n.nav-empty {\n  padding: 6px 24px;\n  font-size: 12px;\n  opacity: 0.35;\n  font-style: italic;\n}\n\n// DM items\n.nav-agents-section {\n  padding: 0;\n}\n\n.nav-dm-section {\n  padding: 0;\n}\n\n.nav-dm-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 10px 6px 14px;\n  margin: 1px 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  gap: 10px;\n  transition: background 0.15s;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  &.selected {\n    background: rgba(244, 172, 57, 0.12) !important;\n\n    .nav-dm-name {\n      font-weight: 600 !important;\n    }\n  }\n\n  .nav-dm-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    flex: 1;\n\n    .nav-dm-name {\n      font-size: 13px;\n      font-weight: 500;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .nav-dm-status {\n      font-size: 11px;\n      opacity: 0.5;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .nav-throttle-btn {\n    width: 24px;\n    height: 24px;\n    min-width: 24px;\n    padding: 0;\n    line-height: 24px;\n    flex-shrink: 0;\n    opacity: 0.4;\n    transition: opacity 0.15s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ::ng-deep .mat-mdc-button-touch-target {\n      width: 24px;\n      height: 24px;\n    }\n\n    .mat-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n      line-height: 14px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #666;\n    }\n\n    &.throttle-enabled .mat-icon {\n      color: #4caf50;\n    }\n\n    &.throttle-safe .mat-icon {\n      color: #ff9800;\n    }\n\n    &.throttle-interrupted .mat-icon {\n      color: #ff9800;\n      animation: interrupt-pulse 1s ease-in-out infinite;\n    }\n\n    &.throttle-enabled, &.throttle-safe, &.throttle-interrupted {\n      opacity: 1;\n    }\n  }\n\n  &:hover .nav-throttle-btn {\n    opacity: 0.8;\n\n    &.throttle-enabled, &.throttle-safe, &.throttle-interrupted {\n      opacity: 1;\n    }\n  }\n}\n\n@keyframes interrupt-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n// --- Archive channel button — muted, brightens on hover ---\n.archive-channel-btn {\n  opacity: 0.35;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n// --- Square button (matches chat-widget) ---\n.square-button {\n  --square-button-size: 28px;\n  --square-icon-size: 18px;\n\n  width: var(--square-button-size);\n  height: var(--square-button-size);\n  padding: 0;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  mat-icon {\n    width: var(--square-icon-size);\n    height: var(--square-icon-size);\n    line-height: var(--square-icon-size);\n    font-size: var(--square-icon-size);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  ::ng-deep .mat-mdc-button-persistent-ripple {\n    border-radius: 0.5rem;\n  }\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: var(--square-button-size);\n    height: var(--square-button-size);\n  }\n}\n\n// --- Main area ---\n.main-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n// --- Agent tab group (mat-tab-group in input area) ---\n.agent-tab-row {\n  position: relative;\n\n  .add-agent-tab-btn {\n    position: absolute;\n    top: 0;\n    right: 32px;\n    width: 32px;\n    height: 33px;\n    padding: 0;\n    line-height: 33px;\n    text-align: center;\n    z-index: 1;\n    opacity: 0.4;\n    transition: opacity 0.15s;\n    overflow: hidden;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    ::ng-deep {\n      .mat-mdc-button-persistent-ripple,\n      .mat-mdc-button-touch-target,\n      .mat-mdc-focus-indicator,\n      .mat-ripple.mat-mdc-button-ripple {\n        top: -4px;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    .mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      margin-top: -7px;\n    }\n  }\n}\n\n.agent-tab-group {\n  // Override the global --preset-primary so the ink bar inherits our muted color\n  --preset-primary: rgba(128, 128, 128, 0.5) !important;\n\n  ::ng-deep {\n    // 2026-09-10: the agent tabs are retired in favour of the \"To:\" addressee\n    // select in the composer row. The tab group stays (per-agent bodies keep\n    // their drafts and the index plumbing is unchanged); only its header goes.\n    .mat-mdc-tab-header { display: none !important; }\n    // Tab header: compact, flush with input area top\n    .mat-mdc-tab-header {\n      border-bottom: 1px solid rgba(128, 128, 128, 0.2);\n    }\n\n    .mat-mdc-tab-labels {\n      gap: 0;\n      padding-right: 64px;\n    }\n\n    .mat-mdc-tab {\n      min-width: 0;\n      padding: 0 14px;\n      height: 32px;\n      min-height: 32px;\n      opacity: 0.45 !important;\n      transition: opacity 0.15s, background-color 0.15s;\n\n      // Kill Material's ripple background so our tab bg shows through\n      .mdc-tab__ripple {\n        background-color: transparent !important;\n      }\n\n      &:hover { opacity: 0.7 !important; }\n\n      &.mdc-tab--active {\n        opacity: 1 !important;\n        border-radius: 0;\n\n        .mdc-tab__text-label {\n          font-weight: 600;\n        }\n      }\n\n      .mdc-tab__text-label {\n        font-size: 12px;\n        font-weight: 500;\n        letter-spacing: 0;\n      }\n    }\n\n    // Ink bar: override Material's CSS custom property + every border property\n    .mat-mdc-tab-header {\n      --mat-tab-active-indicator-color: rgba(128, 128, 128, 0.5);\n      --mat-tab-active-focus-indicator-color: rgba(128, 128, 128, 0.5);\n      --mat-tab-active-hover-indicator-color: rgba(128, 128, 128, 0.5);\n      --mat-tab-active-indicator-color: rgba(128, 128, 128, 0.5);\n\n      .mdc-tab-indicator__content--underline {\n        border-top-width: 2px !important;\n        border-color: rgba(128, 128, 128, 0.5) !important;\n        border-top-color: rgba(128, 128, 128, 0.5) !important;\n      }\n    }\n\n    // Tab body: no padding, no animation jank\n    .mat-mdc-tab-body-wrapper {\n      flex: none;\n    }\n\n    .mat-mdc-tab-body-content {\n      overflow: visible;\n    }\n  }\n}\n\n// Theme-specific tab colors\n:host-context(.dark) .agent-tab-group ::ng-deep {\n  .mat-mdc-tab {\n    .mdc-tab__text-label {\n      color: rgba(255, 255, 255, 0.5) !important;\n    }\n\n    &.mdc-tab--active {\n      background-color: rgba(255, 255, 255, 0.12) !important;\n\n      .mdc-tab__text-label {\n        color: #fff !important;\n      }\n    }\n  }\n}\n\n:host-context(.light) .agent-tab-group ::ng-deep {\n  .mat-mdc-tab {\n    .mdc-tab__text-label {\n      color: rgba(0, 0, 0, 0.55) !important;\n    }\n\n    &.mdc-tab--active {\n      background-color: rgba(0, 0, 0, 0.07) !important;\n\n      .mdc-tab__text-label {\n        color: rgba(0, 0, 0, 0.95) !important;\n      }\n    }\n  }\n}\n\n.agent-tab-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.no-agent-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  opacity: 0.6;\n}\n\n.add-agent-tab-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  opacity: 0.5;\n  transition: opacity 0.15s;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.agent-tab-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.pill-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.agent-controls-inline {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  flex-shrink: 0;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 4px 8px 6px;\n\n  button[mat-icon-button] {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    line-height: 28px;\n    opacity: 0.5;\n    transition: opacity 0.15s;\n\n    &:hover { opacity: 0.85; }\n\n    ::ng-deep .mat-mdc-button-touch-target {\n      width: 28px;\n      height: 28px;\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &.ambient-active {\n      opacity: 1;\n      mat-icon { color: #ef5350; }\n      animation: mic-pulse 1.5s ease-in-out infinite;\n    }\n\n    &.throttle-enabled { opacity: 1; mat-icon { color: #4caf50; } }\n    &.throttle-safe    { opacity: 1; mat-icon { color: #ff9800; } }\n    &.throttle-interrupted { opacity: 1; mat-icon { color: #ff9800; animation: interrupt-pulse 1s ease-in-out infinite; } }\n  }\n}\n\n// --- Inline model selector (sits in agent-controls-inline row) ---\n.model-select-inline {\n  font-size: 11px;\n  width: auto;\n  min-width: 48px;\n  // Tuple triggers read \"Model · credential\" — the input bar has horizontal\n  // room to spare, so let the full tuple show before truncating.\n  max-width: 340px;\n  opacity: 0.55;\n  transition: opacity 0.15s;\n  flex-shrink: 0;\n\n  &:hover { opacity: 0.85; }\n\n  ::ng-deep {\n    .mat-mdc-select-trigger {\n      padding: 2px 4px;\n      min-height: unset;\n      height: 24px;\n    }\n    .mat-mdc-select-value {\n      font-size: 11px;\n      color: inherit;\n    }\n    .mat-mdc-select-arrow-wrapper {\n      transform: scale(0.65);\n    }\n  }\n}\n\n.effort-badge {\n  font-size: 9px;\n  opacity: 0.6;\n  margin-left: 2px;\n\n  &::before {\n    content: '·';\n    margin-right: 2px;\n  }\n}\n\n// .effort-option and .effort-check styled globally in styles.scss\n// (mat-select panel renders in overlay outside component encapsulation)\n\n.usage-bars-inline {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  // The gauge flexes to fill whatever the row leaves it (Ben, 2026-09-10);\n  // the buttons after it sit at the right edge.\n  flex: 1 1 auto;\n  min-width: 96px;\n  width: auto;\n  margin-left: 8px;\n  margin-right: 10px;\n  justify-content: center;\n  padding: 6px 0;\n  cursor: default;\n}\n\n.usage-bar-strip {\n  height: 4px;\n  width: 100%;\n  background: rgba(128, 128, 128, 0.15);\n  flex-shrink: 0;\n  border-radius: 2px;\n  position: relative;\n  cursor: default;\n}\n\n.usage-bar-fill {\n  height: 100%;\n  transition: width 0.4s ease;\n  border-radius: 2px;\n\n  &.usage-normal { background: #5a9e5d; }\n  &.usage-warning { background: #d9a038; }\n  &.usage-critical { background: #c8625a; }\n}\n\n.usage-bar-label {\n  position: absolute;\n  right: 4px;\n  top: -1px;\n  font-size: 8px;\n  line-height: 1;\n  opacity: 0;\n  color: currentColor;\n  pointer-events: none;\n  transition: opacity 0.15s;\n\n  .usage-bar-strip:hover & {\n    opacity: 1;\n  }\n}\n\n::ng-deep .multiline-tooltip .mdc-tooltip__surface {\n  white-space: pre-line;\n  text-align: left;\n  max-width: 350px;\n}\n\n.agent-pill-btn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 0.85;\n  }\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: 28px;\n    height: 28px;\n  }\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.header-bar {\n  display: flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n  .section {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &.left {\n      flex: 1;\n      overflow: hidden;\n    }\n\n    &.right {\n      margin-left: auto;\n      flex-shrink: 0;\n    }\n\n    &.agent-controls {\n      flex-shrink: 0;\n    }\n\n    // Compact icon buttons — 28px touch target, 18px icon (shared by right + agent-controls)\n    &.right, &.agent-controls {\n      button[mat-icon-button] {\n        width: 28px;\n        height: 28px;\n        padding: 0;\n        line-height: 28px;\n        opacity: 0.5;\n        transition: opacity 0.15s;\n\n        &:hover { opacity: 0.85; }\n\n        ::ng-deep .mat-mdc-button-touch-target {\n          width: 28px;\n          height: 28px;\n        }\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n\n        &.ambient-active {\n          opacity: 1;\n          mat-icon { color: #ef5350; }\n          animation: mic-pulse 1.5s ease-in-out infinite;\n        }\n\n        &.throttle-enabled { opacity: 1; mat-icon { color: #4caf50; } }\n        &.throttle-safe    { opacity: 1; mat-icon { color: #ff9800; } }\n        &.throttle-interrupted { opacity: 1; mat-icon { color: #ff9800; animation: interrupt-pulse 1s ease-in-out infinite; } }\n      }\n    }\n  }\n\n  .sidebar-toggle {\n    opacity: 0.6;\n    &:hover { opacity: 1; }\n  }\n\n  .header-title {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    font-weight: 500;\n\n    &.clickable-name {\n      cursor: pointer;\n      border-radius: 4px;\n      padding: 2px 6px;\n      margin: -2px -6px;\n      transition: background 0.15s;\n      &:hover { background: rgba(255, 255, 255, 0.08); }\n    }\n  }\n\n  .header-presence-dot {\n    font-size: 10px;\n    width: 10px;\n    height: 10px;\n    transition: color 0.3s;\n\n    &.pulsing {\n      animation: pulse 1.5s ease-in-out infinite;\n    }\n  }\n\n  .header-channel-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n  }\n\n  .switcher-arrow {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    opacity: 0.5;\n    margin-left: -2px;\n  }\n}\n\n.channel-agent-badge {\n  display: none;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  opacity: 0.7;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n  transition: opacity 0.15s, background 0.15s;\n\n  &:hover {\n    opacity: 1;\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  .pill-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n\n  .badge-arrow {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n    margin-left: -2px;\n  }\n}\n\n// --- Channel header favorites (same pattern as chat-screen message headers) ---\n.header-fav {\n  font-size: 0.8rem;\n  opacity: 1;\n  padding: 2px 6px;\n  border-radius: 4px;\n  user-select: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n\n  &:hover {\n    opacity: 0.9;\n    background-color: rgba(128, 128, 128, 0.15);\n  }\n\n  .fav-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n\n    &.pin-active {\n      color: var(--tool-accent, #1976d2);\n    }\n  }\n\n  &.chip-active {\n    background-color: rgba(128, 128, 128, 0.15);\n  }\n}\n\n::ng-deep .fav-menu-item {\n  .mdc-list-item__primary-text,\n  .mat-mdc-menu-item-text {\n    display: flex !important;\n    align-items: center;\n    width: 100%;\n    gap: 4px;\n  }\n\n  .fav-spacer {\n    flex: 1 1 0;\n    min-width: 8px;\n  }\n\n  .reorder-arrow {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n\n    &.disabled { cursor: default; }\n  }\n\n  &:hover .reorder-arrow {\n    opacity: 0.3;\n    &:hover:not(.disabled) { opacity: 1; }\n    &.disabled { opacity: 0.1; }\n  }\n\n  .fav-star {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.35;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n    &:hover { opacity: 1; }\n  }\n}\n\n::ng-deep .agent-visibility-menu .agent-vis-menu-item {\n  .mdc-list-item__primary-text,\n  .mat-mdc-menu-item-text {\n    display: flex !important;\n    align-items: center;\n    width: 100%;\n    gap: 6px;\n  }\n\n  .pill-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n\n  .agent-vis-name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    min-width: 0;\n  }\n\n  .fav-spacer {\n    flex: 1 1 0;\n    min-width: 8px;\n  }\n\n  .reorder-arrow {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n    &.disabled { cursor: default; }\n  }\n\n  &:hover .reorder-arrow {\n    opacity: 0.3;\n    &:hover:not(.disabled) { opacity: 1; }\n    &.disabled { opacity: 0.1; }\n  }\n\n  .fav-star {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.35;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n    &:hover { opacity: 1; }\n  }\n}\n\n// --- Message area (delegates to app-chat-screen) ---\n.message-area {\n  flex: 1;\n  overflow: hidden;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n// --- Safe mode animation ---\n.safe-mode-active {\n  animation: pulse-safe-mode 2s ease-in-out infinite;\n}\n\n@keyframes pulse-safe-mode {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.3); }\n  50% { box-shadow: 0 0 0 6px rgba(229, 57, 53, 0); }\n}\n\n// --- Interrupt animation ---\n.interrupt-active {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n.empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.3;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 16px;\n  }\n\n  p {\n    font-size: 14px;\n  }\n}\n\n// --- Input area resize divider ---\n.input-resize-divider {\n  height: 4px;\n  cursor: ns-resize;\n  background-color: transparent;\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n  border-top: 1px solid rgba(128, 128, 128, 0.2);\n\n  &:hover {\n    background-color: rgba(128, 128, 128, 0.35);\n  }\n}\n\n.input-area {\n  flex-shrink: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  // When resized, let the tab group and body stretch\n  ::ng-deep {\n    .mat-mdc-tab-body-wrapper {\n      flex: 1 1 auto !important;\n      min-height: 0;\n    }\n\n    .mat-mdc-tab-body {\n      flex: 1 1 auto;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .mat-mdc-tab-body-content {\n      flex: 1 1 auto;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  .agent-tab-group {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .agent-tab-body {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  app-chat-input {\n    margin-bottom: 5px;\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n\n    ::ng-deep {\n      // Remove width constraints — fill the resized area\n      .prompt-box {\n        flex: 1 1 auto;\n        display: flex;\n        flex-direction: column;\n        max-width: none !important;\n        padding: 0 12px !important;\n        width: 100%;\n        box-sizing: border-box;\n        min-height: 0;\n        overflow: hidden;\n      }\n\n      .mat-mdc-form-field {\n        flex: 1 1 auto;\n        display: flex;\n        flex-direction: column;\n        min-height: 0;\n        overflow: hidden;\n      }\n\n      .mat-mdc-text-field-wrapper {\n        flex: 1 1 auto;\n        display: flex;\n        flex-direction: column;\n        min-height: 0;\n        overflow: hidden;\n      }\n\n      .mdc-text-field {\n        flex: 1 1 auto;\n        display: flex;\n        flex-direction: column;\n        min-height: 0;\n      }\n\n      .mat-mdc-form-field-flex {\n        flex: 1 1 auto;\n        align-items: stretch;\n        min-height: 0;\n        overflow: hidden;\n      }\n\n      .mat-mdc-form-field-infix {\n        flex: 1 1 auto;\n        display: flex;\n        flex-direction: column;\n        min-height: 0;\n        overflow: hidden;\n      }\n\n      textarea {\n        flex: 1 1 auto;\n        max-height: none !important;\n        resize: none;\n        overflow-y: auto !important;\n      }\n    }\n  }\n}\n\n// --- Pins pane resize divider ---\n.pins-resize-divider {\n  width: 4px;\n  cursor: ew-resize;\n  background-color: var(--resize-divider-color, transparent);\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: var(--primary-color, #1976d2);\n    opacity: 0.5;\n  }\n}\n\n// --- Pins / Knowledge Graph pane ---\n.pins-pane {\n  min-width: 15%;\n  max-width: 50%;\n  flex-shrink: 0;\n  border-left: 1px solid rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  .pins-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    flex-shrink: 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n    .pins-header-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      opacity: 0.7;\n    }\n\n    .pins-title {\n      font-weight: 600;\n      font-size: 14px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .pins-node-count {\n      font-size: 11px;\n      opacity: 0.6;\n      margin-left: -4px;\n    }\n\n    .flex-spacer { flex: 1; }\n  }\n\n  .search-tabs {\n    display: flex;\n    padding: 0 8px;\n    gap: 2px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n    .search-tab {\n      flex: 1;\n      background: transparent;\n      border: none;\n      color: inherit;\n      font-size: 12px;\n      padding: 6px 0;\n      cursor: pointer;\n      opacity: 0.5;\n      border-bottom: 2px solid transparent;\n      transition: opacity 0.15s, border-color 0.15s;\n\n      &:hover { opacity: 0.8; }\n\n      &.active {\n        opacity: 1;\n        border-bottom-color: rgba(255, 255, 255, 0.6);\n      }\n    }\n  }\n\n  .search-input-bar {\n    display: flex;\n    align-items: center;\n    padding: 6px 8px;\n    gap: 4px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n    .search-pane-input {\n      flex: 1;\n      background: rgba(255, 255, 255, 0.06);\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      border-radius: 4px;\n      color: inherit;\n      font-size: 12px;\n      padding: 5px 8px;\n      outline: none;\n\n      &:focus { border-color: rgba(255, 255, 255, 0.25); }\n      &::placeholder { opacity: 0.4; }\n    }\n\n    .search-regex-toggle {\n      .regex-label {\n        font-size: 12px;\n        font-family: monospace;\n        font-weight: 600;\n        opacity: 0.5;\n      }\n\n      &.active .regex-label { opacity: 1; color: #90caf9; }\n    }\n  }\n\n  .search-result-count {\n    padding: 4px 12px;\n    font-size: 11px;\n    opacity: 0.5;\n  }\n\n  .pins-graph-container {\n    flex: 1;\n    overflow: hidden;\n    position: relative;\n\n    app-knowledge-graph-widget {\n      display: block;\n      width: 100%;\n      height: 100%;\n\n      ::ng-deep .widget-body {\n        height: 100%;\n      }\n    }\n  }\n\n  .pins-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px 0;\n  }\n\n  .pin-card {\n    padding: 10px 12px;\n\n    &.kg-card {\n      height: 158px;\n      box-sizing: border-box;\n      display: flex;\n      flex-direction: column;\n\n      .pin-card-header { flex-shrink: 0; }\n      .pin-card-content { max-height: none; flex: 1; }\n    }\n\n    .pin-card-header {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      margin-bottom: 6px;\n      flex-shrink: 0;\n\n      .pin-role-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n\n      .pin-timestamp {\n        font-size: 11px;\n        opacity: 0.7;\n      }\n\n      .kg-jump-icon {\n        font-size: 14px;\n        width: 14px;\n        height: 14px;\n        opacity: 0;\n        transition: opacity 0.15s;\n        color: rgba(255, 255, 255, 0.5);\n      }\n    }\n\n    .pin-unpin-icon {\n      font-size: 15px;\n      width: 15px;\n      height: 15px;\n      color: #f4ac39;\n      opacity: 0.7;\n      cursor: pointer;\n\n      &:hover { opacity: 1; }\n    }\n\n    &.clickable {\n      cursor: pointer;\n      transition: background 0.15s;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.06);\n\n        .kg-jump-icon { opacity: 1; }\n      }\n    }\n\n    .pin-card-content {\n      font-size: 13px;\n      line-height: 1.5;\n      overflow: hidden;\n      max-height: 120px;\n      mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n      -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n\n      ::ng-deep {\n        h1, h2, h3, h4 { font-size: 14px; margin: 4px 0; }\n        p { margin: 4px 0; }\n        pre { font-size: 11px; padding: 6px; overflow-x: auto; }\n        ul, ol { padding-left: 20px; margin: 4px 0; }\n        code { font-size: 12px; }\n        app-tool-message { display: block; }\n      }\n    }\n  }\n\n  .kg-msg-loading {\n    font-size: 12px;\n    opacity: 0.5;\n    padding: 4px 0;\n\n    .shimmer-lines {\n      .shimmer-line {\n        height: 10px;\n        border-radius: 3px;\n        background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);\n        background-size: 200% 100%;\n        animation: shimmer 1.5s infinite;\n        margin-bottom: 6px;\n\n        &:nth-child(1) { width: 90%; }\n        &:nth-child(2) { width: 70%; }\n        &:nth-child(3) { width: 50%; }\n      }\n    }\n\n    @keyframes shimmer {\n      0% { background-position: 200% 0; }\n      100% { background-position: -200% 0; }\n    }\n  }\n\n  .kg-msg-excerpt {\n    font-size: 12px;\n    opacity: 0.6;\n    line-height: 1.4;\n    font-style: italic;\n  }\n\n  .kg-filter-bar {\n    display: flex;\n    align-items: center;\n    padding: 4px 12px 4px 8px;\n    gap: 6px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n    .kg-filter-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      opacity: 0.4;\n    }\n\n    .kg-filter-input {\n      flex: 1;\n      background: transparent;\n      border: none;\n      outline: none;\n      color: inherit;\n      font-size: 12px;\n      padding: 4px 0;\n\n      &::placeholder { opacity: 0.4; }\n    }\n\n    .kg-filter-count {\n      font-size: 11px;\n      opacity: 0.5;\n      white-space: nowrap;\n    }\n\n    .kg-filter-clear {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n      cursor: pointer;\n      opacity: 0.4;\n\n      &:hover { opacity: 0.8; }\n    }\n  }\n\n  .kg-no-results {\n    padding: 16px 12px;\n    font-size: 12px;\n    opacity: 0.5;\n    text-align: center;\n  }\n\n  // --- Calendar ---\n  .calendar-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 4px;\n  }\n\n  .calendar-loading {\n    padding: 16px;\n    font-size: 12px;\n    opacity: 0.5;\n    text-align: center;\n  }\n\n  ::ng-deep mat-calendar {\n    width: 100%;\n\n    .mat-calendar-header {\n      padding: 4px 8px 0;\n    }\n\n    .mat-calendar-body-cell-content {\n      border-radius: 4px;\n    }\n\n    .cal-heat-1 .mat-calendar-body-cell-content {\n      background: rgba(144, 202, 249, 0.15);\n    }\n    .cal-heat-2 .mat-calendar-body-cell-content {\n      background: rgba(144, 202, 249, 0.25);\n    }\n    .cal-heat-3 .mat-calendar-body-cell-content {\n      background: rgba(144, 202, 249, 0.38);\n    }\n    .cal-heat-4 .mat-calendar-body-cell-content {\n      background: rgba(144, 202, 249, 0.55);\n    }\n  }\n\n  .calendar-hours {\n    margin-top: 12px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    padding-top: 8px;\n  }\n\n  .calendar-day-label {\n    font-size: 12px;\n    font-weight: 500;\n    padding: 0 4px 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .calendar-day-total {\n      font-size: 11px;\n      opacity: 0.5;\n      font-weight: 400;\n    }\n\n    .calendar-view-all {\n      background: none;\n      border: 1px solid rgba(255, 255, 255, 0.15);\n      color: inherit;\n      font-size: 10px;\n      padding: 2px 8px;\n      border-radius: 3px;\n      cursor: pointer;\n      opacity: 0.6;\n      transition: opacity 0.15s;\n      &:hover { opacity: 1; }\n    }\n  }\n\n  .calendar-hour-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 3px;\n\n    .calendar-hour {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 6px 2px;\n      border-radius: 4px;\n      font-size: 11px;\n      transition: background 0.15s;\n\n      &.has-messages {\n        cursor: pointer;\n        &:hover { background: rgba(255, 255, 255, 0.12); }\n      }\n\n      &[data-heat=\"0\"] { opacity: 0.25; }\n      &[data-heat=\"1\"] { background: rgba(144, 202, 249, 0.08); }\n      &[data-heat=\"2\"] { background: rgba(144, 202, 249, 0.16); }\n      &[data-heat=\"3\"] { background: rgba(144, 202, 249, 0.24); }\n      &[data-heat=\"4\"] { background: rgba(144, 202, 249, 0.35); }\n\n      .calendar-hour-label { font-size: 10px; }\n      .calendar-hour-count { font-size: 9px; opacity: 0.6; }\n    }\n  }\n}\n\n// --- Compact mode presence dot for agent selector menu ---\n.presence-dot-menu {\n  font-size: 12px;\n  width: 12px;\n  height: 12px;\n  margin-right: 8px;\n}\n\n.active-agent {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n// Menu section labels inside mat-menu\n.menu-section-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.4;\n  padding: 8px 16px 2px;\n}\n\n// --- Combined selector (hidden by default, shown in compact mode) ---\n.combined-selector-mobile {\n  display: none;\n}\n\n.combined-selector-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-transform: none;\n  line-height: 1.2;\n\n  .agent-badge {\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .session-name {\n    font-size: 11px;\n    opacity: 0.6;\n  }\n}\n\n// ============================================================================\n// Container-query compact mode: triggers on widget width, not viewport.\n// ============================================================================\n\n// At 500px: compress chips to icon-only\n@container heartbeat (max-width: 500px) {\n  ::ng-deep app-header-chips .header-chip .chip-folder-label {\n    display: none;\n  }\n\n  ::ng-deep app-header-chips .header-chip .chip-label {\n    display: none;\n  }\n}\n\n// At 600px: hide sidebar, show combined dropdown selector\n@container heartbeat (max-width: 600px) {\n  // Hide the agent sidebar — use combined selector instead\n  .agent-sidebar {\n    display: none !important;\n  }\n\n  // Hide the sidebar resize divider too\n  .sidebar-resize-divider {\n    display: none !important;\n  }\n\n  // Show combined agent/session selector — full width\n  .combined-selector-mobile {\n    display: flex !important;\n    width: 100% !important;\n    max-width: none !important;\n\n    // Material button inner wrapper must also stretch\n    ::ng-deep .mdc-button__label {\n      width: 100%;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  // Hide desktop-only elements, show mobile-only\n  .desktop-only {\n    display: none !important;\n  }\n\n  // Override: keep header chips visible as icon-only in compact mode\n  app-header-chips.desktop-only {\n    display: flex !important;\n  }\n\n  // Hide agent tabs in compact mode — mobile selector handles switching\n  .agent-tab-group ::ng-deep .mat-mdc-tab-header {\n    display: none !important;\n  }\n\n  // Compact agent controls for mobile — show essential controls only\n  .agent-controls-inline {\n    padding: 4px 40px 6px 8px;\n    justify-content: flex-start;\n    gap: 4px;\n\n    // Bigger touch targets on mobile (44px minimum per Apple HIG)\n    button[mat-icon-button] {\n      width: 40px !important;\n      height: 40px !important;\n\n      ::ng-deep .mat-mdc-button-touch-target {\n        width: 44px !important;\n        height: 44px !important;\n      }\n\n      mat-icon {\n        font-size: 22px !important;\n        width: 22px !important;\n        height: 22px !important;\n      }\n    }\n\n    // Hide model selector on mobile — not enough room\n    .model-select-inline {\n      display: none !important;\n    }\n\n    // Compact usage bars for mobile — fill remaining space\n    .usage-bars-inline {\n      min-width: 48px;\n      margin-left: auto;\n      padding: 8px 0;\n    }\n\n    // Hide DM, settings, ambient mic, and throttle buttons on mobile\n    // (mic moves to chat-input, others move to kebab)\n    .dm-button-mobile-hide,\n    .settings-btn-mobile-hide {\n      display: none !important;\n    }\n  }\n\n  ::ng-deep app-header-chips .header-chip {\n    padding: 3px 5px;\n    gap: 0;\n\n    > span {\n      display: none;\n    }\n  }\n\n  .header-bar .left.section {\n    gap: 0;\n    width: 100%;\n  }\n\n  // Hide pins pane at narrow widths — not enough room\n  .pins-pane {\n    display: none !important;\n  }\n\n  // Align kebab with the controls row (tab headers are hidden on mobile)\n  .agent-tab-row .add-agent-tab-btn {\n    top: 8px;\n  }\n\n  // Show agent badge in header on mobile (hidden on desktop where tabs show the agent)\n  .channel-agent-badge {\n    display: inline-flex !important;\n  }\n}\n\n\n@keyframes channel-pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.35; transform: scale(0.75); }\n}\n\n@keyframes mic-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.jump-to-latest-btn {\n  position: absolute;\n  bottom: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 16px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(30, 30, 30, 0.95);\n  color: #ccc;\n  font-size: 13px;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  transition: all 0.15s;\n\n  &:hover {\n    background: rgba(50, 50, 50, 0.95);\n    color: #fff;\n  }\n\n  .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n// ═══ Hands-free mode overlay ═══\n.hands-free-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n  background: radial-gradient(ellipse at center, #1a1a2e 0%, #0d0d1a 100%);\n\n  .hands-free-status {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    position: relative;\n  }\n\n  .hands-free-orb {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.4s ease;\n\n    .orb-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      color: #fff;\n    }\n\n    &.orb-listening {\n      background: radial-gradient(circle, #ef5350 0%, #c62828 100%);\n      box-shadow: 0 0 40px rgba(239, 83, 80, 0.4);\n      animation: orb-pulse 2s ease-in-out infinite;\n    }\n\n    &.orb-thinking {\n      background: radial-gradient(circle, #42a5f5 0%, #1565c0 100%);\n      box-shadow: 0 0 40px rgba(66, 165, 245, 0.4);\n      animation: orb-spin-glow 1.5s ease-in-out infinite;\n    }\n\n    &.orb-speaking {\n      background: radial-gradient(circle, #66bb6a 0%, #2e7d32 100%);\n      box-shadow: 0 0 40px rgba(102, 187, 106, 0.4);\n      animation: orb-wave 1s ease-in-out infinite;\n    }\n\n    &.orb-paused {\n      background: radial-gradient(circle, #78909c 0%, #37474f 100%);\n      box-shadow: 0 0 20px rgba(120, 144, 156, 0.3);\n      animation: none;\n    }\n\n    &.orb-replaying {\n      background: radial-gradient(circle, #ab47bc 0%, #6a1b9a 100%);\n      box-shadow: 0 0 40px rgba(171, 71, 188, 0.4);\n      animation: orb-wave 1s ease-in-out infinite;\n    }\n  }\n\n  .hands-free-speed-toast {\n    position: absolute;\n    top: -40px;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 28px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.9);\n    letter-spacing: 2px;\n    pointer-events: none;\n    z-index: 1;\n    animation: speed-toast-fade 1.2s ease-out forwards;\n  }\n\n  @keyframes speed-toast-fade {\n    0% { opacity: 1; transform: scale(1.2); }\n    70% { opacity: 1; transform: scale(1); }\n    100% { opacity: 0; transform: scale(0.9); }\n  }\n\n\n  .hands-free-buttons {\n    display: flex;\n    gap: 16px;\n    width: min(520px, calc(100% - 32px));\n    margin-top: 28px;\n  }\n\n  .hands-free-btn {\n    flex: 1 1 0;\n    min-height: 72px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    border-radius: 18px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 22px;\n    font-weight: 500;\n    cursor: pointer;\n    mat-icon { font-size: 28px; width: 28px; height: 28px; }\n    &:active { background: rgba(255, 255, 255, 0.26); }\n    &:disabled { opacity: 0.35; cursor: default; }\n    &.primary { background: rgba(255, 255, 255, 0.18); }\n    &.primary.stop {\n      background: rgba(229, 57, 53, 0.85);\n      border-color: rgba(229, 57, 53, 0.9);\n    }\n  }\n\n  .hands-free-speed {\n    margin-top: 14px;\n    padding: 8px 16px;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    background: transparent;\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 14px;\n    cursor: pointer;\n    &:active { background: rgba(255, 255, 255, 0.15); }\n  }\n\n  .hands-free-label {\n    font-size: 24px;\n    font-weight: 300;\n    color: rgba(255, 255, 255, 0.9);\n    letter-spacing: 2px;\n    text-transform: uppercase;\n  }\n\n  .hands-free-agent {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.4);\n  }\n\n  .hands-free-transcript {\n    max-width: 80%;\n    font-size: 20px;\n    color: rgba(255, 255, 255, 0.6);\n    text-align: center;\n    font-style: italic;\n    line-height: 1.4;\n    min-height: 56px;\n    max-height: 120px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n  }\n\n  .hands-free-stop {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 32px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 24px;\n    background: rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 16px;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:hover, &:active {\n      background: rgba(255, 255, 255, 0.15);\n      color: #fff;\n    }\n\n    .mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n@keyframes orb-pulse {\n  0%, 100% { transform: scale(1); box-shadow: 0 0 40px rgba(239, 83, 80, 0.4); }\n  50% { transform: scale(1.08); box-shadow: 0 0 60px rgba(239, 83, 80, 0.6); }\n}\n\n@keyframes orb-spin-glow {\n  0%, 100% { box-shadow: 0 0 40px rgba(66, 165, 245, 0.4); }\n  50% { box-shadow: 0 0 60px rgba(66, 165, 245, 0.7); }\n}\n\n@keyframes orb-wave {\n  0%, 100% { transform: scale(1); }\n  25% { transform: scale(1.05); }\n  75% { transform: scale(0.97); }\n}\n\n// --- Orchestration panel ---\n.orchestration-panel {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 12px 16px;\n  background: rgba(0, 0, 0, 0.15);\n  max-height: 300px;\n  overflow-y: auto;\n\n  .orch-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  .orch-title {\n    font-weight: 500;\n    font-size: 13px;\n    opacity: 0.9;\n  }\n\n\n  .orch-select-field {\n    width: 100%;\n    ::ng-deep .mat-mdc-form-field-infix {\n      padding-top: 8px;\n      padding-bottom: 8px;\n      display: inline-flex;\n      align-items: center;\n    }\n  }\n\n  .orch-scope-badge {\n    font-size: 10px;\n    opacity: 0.5;\n    margin-left: 8px;\n    text-transform: uppercase;\n  }\n\n  .orch-description {\n    font-size: 12px;\n    opacity: 0.6;\n    margin: -4px 0 8px 2px;\n  }\n\n  .orch-fields {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: flex-start;\n  }\n\n  .orch-field {\n    flex: 1;\n    min-width: 140px;\n    max-width: 280px;\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      background-color: transparent !important;\n      height: 0;\n      overflow: hidden;\n    }\n    ::ng-deep .mat-mdc-form-field-infix {\n      display: inline-flex;\n      align-items: center;\n    }\n  }\n\n  .orch-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 4px;\n  }\n\n  .orch-go-btn {\n    mat-icon { font-size: 18px; margin-right: 4px; }\n  }\n\n  .orch-state-badge {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    text-transform: uppercase;\n    font-weight: 500;\n\n    &.orch-state-running { background: rgba(33, 150, 243, 0.2); color: #42a5f5; }\n    &.orch-state-waiting { background: rgba(255, 152, 0, 0.2); color: #ffa726; }\n    &.orch-state-done { background: rgba(76, 175, 80, 0.2); color: #66bb6a; }\n    &.orch-state-error { background: rgba(244, 67, 54, 0.2); color: #ef5350; }\n    &.orch-state-aborted { background: rgba(158, 158, 158, 0.2); color: #9e9e9e; }\n  }\n\n  .orch-step {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    opacity: 0.8;\n    margin: 4px 0;\n\n    .orch-step-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      &.error { color: #ef5350; }\n    }\n  }\n\n  .orch-gate {\n    margin: 8px 0;\n    padding: 8px 12px;\n    border-left: 3px solid #ffa726;\n    background: rgba(255, 152, 0, 0.05);\n    border-radius: 0 4px 4px 0;\n\n    .orch-gate-prompt {\n      font-size: 13px;\n      margin-bottom: 8px;\n    }\n\n    .orch-gate-buttons {\n      display: flex;\n      gap: 8px;\n      flex-wrap: wrap;\n      margin-bottom: 8px;\n    }\n\n    .orch-gate-btn {\n      font-size: 12px;\n    }\n\n    .orch-gate-notes {\n      width: 100%;\n      ::ng-deep .mat-mdc-form-field-infix { padding-top: 6px; padding-bottom: 6px; }\n    }\n  }\n}\n\n.agent-tab-row .orch-toggle-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 32px;\n  height: 33px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  opacity: 0.4;\n  transition: opacity 0.15s;\n  &:hover { opacity: 1; }\n  mat-icon { font-size: 18px; }\n}\n\n.agent-tab-row .terminal-toggle-btn {\n  position: absolute;\n  top: 0;\n  right: 64px;\n  width: 32px;\n  height: 33px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  opacity: 0.4;\n  transition: opacity 0.15s;\n  &:hover { opacity: 1; }\n  &.active { opacity: 1; color: #42a5f5; }\n  &.throb {\n    opacity: 1;\n    animation: throb 0.6s ease-in-out 4;\n  }\n  mat-icon { font-size: 18px; }\n}\n\n// --- \"To:\" addressee select (composer row, 2026-09-10) ---\n.addressee-select {\n  font-size: 13px;\n  width: auto;\n  min-width: 160px;\n  max-width: 320px;\n  opacity: 0.9;\n  flex-shrink: 0;\n  margin-right: 10px;\n  padding: 0 6px;\n  border-radius: 6px;\n  background: rgba(128, 128, 128, 0.08);\n  transition: background 0.15s;\n  &:hover { background: rgba(128, 128, 128, 0.16); }\n\n  .to-label { opacity: 0.55; margin-right: 7px; }\n  .pill-dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 7px; vertical-align: middle; }\n  .to-icon { font-size: 16px; width: 16px; height: 16px; vertical-align: middle; margin-right: 6px; }\n\n  ::ng-deep {\n    .mat-mdc-select-trigger { padding: 4px 4px; min-height: unset; height: 28px; }\n    .mat-mdc-select-value { font-size: 13px; color: inherit; overflow: visible; }\n    .mat-mdc-select-value-text { white-space: nowrap; }\n    .mat-mdc-select-arrow-wrapper { transform: scale(0.8); }\n  }\n}\n\n.agent-menu .menu-check, ::ng-deep .agent-menu .menu-check { margin-left: auto; margin-right: 0; opacity: 0.7; }\n\n.agent-controls-inline .terminal-inline-btn {\n  &.active { opacity: 1 !important; color: #42a5f5; }\n  &.throb { opacity: 1 !important; animation: throb 0.6s ease-in-out 4; }\n}\n\n// Right-side channel buttons (orchestrations, manage agents) now sit on the\n// composer controls row instead of the retired tab header.\n// Thin rule between the casual half of the row (To:, model, usage) and the\n// power trio (terminal, orchestrations, settings) — Ben, 2026-09-10.\n.agent-controls-inline .power-divider {\n  flex: 0 0 1px;\n  height: 18px;\n  margin: 0 10px 0 4px;\n  background: rgba(128, 128, 128, 0.35);\n}\n\n.agent-controls-inline .orch-inline-btn {\n  position: relative;\n  &.active { opacity: 1 !important; color: #42a5f5; }\n  .orch-badge { position: absolute; top: -2px; right: -6px; font-size: 9px; line-height: 1; padding: 1px 4px; border-radius: 6px; background: rgba(66, 165, 245, 0.85); color: #fff; }\n}\n\n@keyframes throb {\n  0%, 100% { transform: scale(1); color: inherit; }\n  50% { transform: scale(1.3); color: #42a5f5; }\n}\n\n.terminal-view {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  app-terminal {\n    flex: 1;\n    display: flex;\n    ::ng-deep .content {\n      flex: 1;\n      display: flex;\n    }\n    ::ng-deep ng-terminal {\n      flex: 1;\n    }\n  }\n}\n\n.orch-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  font-size: 9px;\n  background: #42a5f5;\n  color: white;\n  border-radius: 8px;\n  padding: 1px 5px;\n  line-height: 1;\n}\n\n// Hidden anchor for the right-click throttle menu — positioned at the cursor\n// before the menu opens, occupies no space.\n.throttle-ctx-anchor {\n  position: fixed;\n  width: 0;\n  height: 0;\n  visibility: hidden;\n}\n\n/* Pre-emptive auth banner (expired/expiring Claude login) */\n.auth-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 8px 6px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n\n  mat-icon { font-size: 18px; width: 18px; height: 18px; }\n  .auth-banner-text { flex: 1; }\n\n  &.warn {\n    background: rgba(229, 192, 123, 0.14);\n    border: 1px solid rgba(229, 192, 123, 0.45);\n  }\n  &.error {\n    background: rgba(224, 108, 117, 0.14);\n    border: 1px solid rgba(224, 108, 117, 0.45);\n  }\n}\n\n/* Usage-limit card */\n.limit-banner {\n  .limit-banner-select {\n    max-width: 220px; padding: 4px 8px; border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.25);\n    background: transparent; color: inherit; font: inherit;\n    option { color: initial; }\n  }\n  .limit-banner-close {\n    width: 28px; height: 28px; line-height: 28px; padding: 0;\n    mat-icon { font-size: 16px; width: 16px; height: 16px; }\n  }\n}\n\n/* Inline re-auth flow (expanded auth banner) */\n.auth-banner {\n  .auth-banner-row { display: flex; align-items: center; gap: 8px; }\n  &.expanded { border-color: var(--accent-color, #61afef); }\n  &.expanded, &.ok { display: block; }\n\n  .auth-reauth-flow {\n    display: flex; flex-direction: column; gap: 8px; padding: 4px 2px;\n    &.ok { color: #98c379; }\n  }\n  .auth-reauth-step { font-size: 13px; opacity: 0.85; }\n  .auth-reauth-link { cursor: pointer; text-decoration: underline; margin-left: 6px; }\n  .auth-reauth-inputs { display: flex; align-items: center; gap: 8px; }\n  .auth-reauth-input {\n    flex: 1; max-width: 420px;\n    padding: 6px 10px; border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.25);\n    background: transparent; color: inherit; font: inherit;\n    &:focus { border-color: var(--accent-color, #61afef); outline: none; }\n  }\n  .auth-reauth-error { color: #e06c75; font-size: 13px; }\n}\n\n/* Presence v1: \"Your devices\" sidebar section */\n.nav-device-item { cursor: default; }\n.device-online-dot {\n  width: 8px; height: 8px; border-radius: 50%;\n  background: #98c379;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.nav-device-item { cursor: pointer; }\n.remote-team-header {\n  padding: 4px 12px 2px 28px;\n  font-size: 10px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.55;\n}\n.remote-channel-item { opacity: 0.85; }\n\n/* Remote channel view (Presence slice 3/4-lite) */\n.remote-channel-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n\n  .message-area { flex: 1; min-height: 0; }\n}\n.remote-channel-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n  .remote-channel-title { font-weight: 600; }\n  .remote-badge {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background: rgba(97, 175, 239, 0.15);\n    border: 1px solid rgba(97, 175, 239, 0.4);\n  }\n  .remote-header-spacer { flex: 1; }\n}\n\n// (model, credential) tuple rows: credential as a subtle property after the\n// model. mat-option content renders in the CDK overlay (outside this\n// component's DOM), so ::ng-deep is required for the style to reach it.\n::ng-deep .model-select-panel .pool-cred {\n  opacity: 0.55;\n  font-size: 0.85em;\n}\n\n// Channel header: count of pinned messages (only rendered when > 0).\n.pin-count-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n\n  .pin-count {\n    font-size: 11px;\n    opacity: 0.8;\n  }\n}\n\n\n/* ── Conversations with other people's agents (standing orders) ─────────── */\n\n.nav-guest-header { margin-top: 10px; }\n.nav-guest-item .nav-guest-icon { color: #7fb4ff; }\n\n.guest-strip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n\n  .guest-strip-icon { color: #7fb4ff; flex: none; }\n  .guest-strip-text { min-width: 0; flex: 1; }\n  .guest-strip-title { font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n  .guest-strip-state {\n    margin-left: 8px; padding: 1px 8px; border-radius: 10px; font-size: 11px; font-weight: 500;\n    background: rgba(244, 172, 57, 0.18); color: #f4ac39;\n  }\n  .guest-strip-about { font-size: 12px; opacity: 0.7; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n  .guest-strip-notice {\n    display: flex; align-items: center; gap: 6px; flex: none; max-width: 46%;\n    font-size: 12px; opacity: 0.75;\n    mat-icon { font-size: 16px; width: 16px; height: 16px; flex: none; }\n  }\n}\n\n.guest-composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 10px 14px 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n\n  .guest-input {\n    flex: 1;\n    min-height: 44px;\n    max-height: 30vh;\n    resize: vertical;\n    padding: 10px 14px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(255, 255, 255, 0.04);\n    color: inherit;\n    font: inherit;\n    outline: none;\n\n    &:focus { border-color: #7fb4ff; }\n    &:disabled { opacity: 0.55; cursor: not-allowed; }\n  }\n}\n\n// Host affinity chip beside the model select (only on nodes with linked hosts)\n.affinity-select-inline {\n  max-width: 220px;\n}\n.aff-dot {\n  display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 8px; vertical-align: 1px;\n  &.alive { background: #4caf50; box-shadow: 0 0 4px rgba(76, 175, 80, 0.7); }\n  &.off { background: #9e9e9e; }\n}\n.aff-home {\n  padding: 6px 16px 8px; font-size: 12px; opacity: 0.7; border-top: 1px solid rgba(128, 128, 128, 0.25); margin-top: 4px; cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
